// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddClientContactsData, AddClientContactsErrors, AddClientContactsResponses, AddClientNameData, AddClientNameErrors, AddClientNameResponses, AttachTriageEntryData, AttachTriageEntryErrors, AttachTriageEntryResponses, CancelClientImportData, CancelClientImportErrors, CancelClientImportResponses, CancelQrConnectData, CancelQrConnectErrors, CancelQrConnectResponses, ChangeChannelTokenData, ChangeChannelTokenErrors, ChangeChannelTokenResponses, CheckConciergeModelData, CheckConciergeModelErrors, CheckConciergeModelResponses, CloseTriageEntryData, CloseTriageEntryErrors, CloseTriageEntryResponses, CommitClientImportData, CommitClientImportErrors, CommitClientImportResponses, ConnectByTokenData, ConnectByTokenErrors, ConnectByTokenResponses, CreateBookingData, CreateBookingErrors, CreateBookingResponses, CreateContentData, CreateContentErrors, CreateContentResponses, CreateScenarioData, CreateScenarioErrors, CreateScenarioFromTemplateData, CreateScenarioFromTemplateErrors, CreateScenarioFromTemplateResponses, CreateScenarioResponses, DeleteApartmentVariableKeyData, DeleteApartmentVariableKeyErrors, DeleteApartmentVariableKeyResponses, DeleteChannelData, DeleteChannelErrors, DeleteChannelResponses, DeleteContentData, DeleteContentErrors, DeleteContentResponses, DeleteScenarioData, DeleteScenarioErrors, DeleteScenarioResponses, DisableChannelData, DisableChannelErrors, DisableChannelResponses, DismissAiDraftData, DismissAiDraftErrors, DismissAiDraftResponses, DryRunScenarioData, DryRunScenarioErrors, DryRunScenarioResponses, EnableChannelData, EnableChannelErrors, EnableChannelResponses, FillApartmentVariableData, FillApartmentVariableErrors, FillApartmentVariableResponses, GetApartmentData, GetApartmentErrors, GetApartmentResponses, GetApartmentVariableMatrixData, GetApartmentVariableMatrixErrors, GetApartmentVariableMatrixResponses, GetBadgesData, GetBadgesErrors, GetBadgesResponses, GetBookingData, GetBookingErrors, GetBookingFormReferenceData, GetBookingFormReferenceErrors, GetBookingFormReferenceResponses, GetBookingGuestScreenData, GetBookingGuestScreenErrors, GetBookingGuestScreenResponses, GetBookingResponses, GetBrandData, GetBrandErrors, GetBrandResponses, GetChannelCascadeData, GetChannelCascadeErrors, GetChannelCascadeResponses, GetChannelCatalogData, GetChannelCatalogErrors, GetChannelCatalogResponses, GetChannelLimitsData, GetChannelLimitsErrors, GetChannelLimitsResponses, GetChessPeriodData, GetChessPeriodErrors, GetChessPeriodResponses, GetClientCatalogData, GetClientCatalogErrors, GetClientCatalogResponses, GetClientData, GetClientErrors, GetClientImportData, GetClientImportErrors, GetClientImportResponses, GetClientResponses, GetClientsSummaryData, GetClientsSummaryErrors, GetClientsSummaryResponses, GetConciergeData, GetConciergeErrors, GetConciergeResponses, GetContentAuthoringCatalogData, GetContentAuthoringCatalogErrors, GetContentAuthoringCatalogResponses, GetContentData, GetContentErrors, GetContentResponses, GetConversationData, GetConversationErrors, GetConversationResponses, GetConversationTimelineData, GetConversationTimelineErrors, GetConversationTimelineResponses, GetDashboardData, GetDashboardErrors, GetDashboardResponses, GetFlowSliceData, GetFlowSliceErrors, GetFlowSliceResponses, GetMeData, GetMeErrors, GetMeResponses, GetPaymentSettingsData, GetPaymentSettingsErrors, GetPaymentSettingsResponses, GetPolicyData, GetPolicyErrors, GetPolicyResponses, GetQrConnectData, GetQrConnectErrors, GetQrConnectResponses, GetScenarioBotMapData, GetScenarioBotMapErrors, GetScenarioBotMapResponses, GetScenarioCatalogData, GetScenarioCatalogErrors, GetScenarioCatalogResponses, GetScenarioData, GetScenarioErrors, GetScenarioResponses, GetSourceSyncScopeData, GetSourceSyncScopeErrors, GetSourceSyncScopeResponses, GetTaskQueueData, GetTaskQueueErrors, GetTaskQueueResponses, ImportApartmentVariablesData, ImportApartmentVariablesErrors, ImportApartmentVariablesResponses, ListApartmentsData, ListApartmentsErrors, ListApartmentsResponses, ListAuditEventsData, ListAuditEventsErrors, ListAuditEventsResponses, ListBookingsData, ListBookingsErrors, ListBookingsResponses, ListBotLinksData, ListBotLinksErrors, ListBotLinksResponses, ListChannelEventsData, ListChannelEventsErrors, ListChannelEventsResponses, ListChannelsData, ListChannelsErrors, ListChannelsResponses, ListChessObjectsData, ListChessObjectsErrors, ListChessObjectsResponses, ListClientImportRowsData, ListClientImportRowsErrors, ListClientImportRowsResponses, ListClientsData, ListClientsErrors, ListClientsResponses, ListCompaniesData, ListCompaniesErrors, ListCompaniesResponses, ListContentData, ListContentErrors, ListContentResponses, ListContentRolesData, ListContentRolesErrors, ListContentRolesResponses, ListContentRoleStatusData, ListContentRoleStatusErrors, ListContentRoleStatusResponses, ListConversationsData, ListConversationsErrors, ListConversationsResponses, ListGatedRolesData, ListGatedRolesErrors, ListGatedRolesResponses, ListNotificationsData, ListNotificationsErrors, ListNotificationsResponses, ListPlatformServicesData, ListPlatformServicesErrors, ListPlatformServicesResponses, ListScenariosData, ListScenariosErrors, ListScenariosResponses, ListScenarioTemplatesData, ListScenarioTemplatesErrors, ListScenarioTemplatesResponses, ListSecretRevealsData, ListSecretRevealsErrors, ListSecretRevealsResponses, ListSourcesData, ListSourcesErrors, ListSourcesResponses, ListTriageData, ListTriageErrors, ListTriageResponses, LogoutData, LogoutResponses, MarkNotificationsReadData, MarkNotificationsReadErrors, MarkNotificationsReadResponses, PreviewContentData, PreviewContentErrors, PreviewContentResponses, PublishContentData, PublishContentErrors, PublishContentResponses, PublishScenarioData, PublishScenarioErrors, PublishScenarioResponses, RecordBookingPaymentData, RecordBookingPaymentErrors, RecordBookingPaymentResponses, RefreshQrConnectData, RefreshQrConnectErrors, RefreshQrConnectResponses, RelinkChannelData, RelinkChannelErrors, RelinkChannelResponses, RemoveClientContactData, RemoveClientContactErrors, RemoveClientContactResponses, RenameScenarioData, RenameScenarioErrors, RenameScenarioResponses, ResendGuestLinkData, ResendGuestLinkErrors, ResendGuestLinkResponses, RunBookingActionData, RunBookingActionErrors, RunBookingActionResponses, RunBookingInterventionData, RunBookingInterventionErrors, RunBookingInterventionResponses, RunTaskActionData, RunTaskActionErrors, RunTaskActionResponses, SaveApartmentSecretData, SaveApartmentSecretErrors, SaveApartmentSecretResponses, SaveBrandData, SaveBrandErrors, SaveBrandResponses, SaveChannelCascadeData, SaveChannelCascadeErrors, SaveChannelCascadeResponses, SaveConciergeData, SaveConciergeErrors, SaveConciergeResponses, SaveContentData, SaveContentErrors, SaveContentResponses, SaveDepositSettingsData, SaveDepositSettingsErrors, SaveDepositSettingsResponses, SavePolicyData, SavePolicyErrors, SavePolicyResponses, SaveScenarioDraftData, SaveScenarioDraftErrors, SaveScenarioDraftResponses, SearchData, SearchErrors, SearchResponses, SendAiDraftData, SendAiDraftErrors, SendAiDraftResponses, SendMessageData, SendMessageErrors, SendMessageResponses, SetApartmentSecretLabelData, SetApartmentSecretLabelErrors, SetApartmentSecretLabelResponses, SetApartmentVariablesData, SetApartmentVariablesErrors, SetApartmentVariablesResponses, SetClientDisplayNameData, SetClientDisplayNameErrors, SetClientDisplayNameResponses, SetConversationModeData, SetConversationModeErrors, SetConversationModeResponses, StartQrConnectData, StartQrConnectErrors, StartQrConnectResponses, SubmitQrPasswordData, SubmitQrPasswordErrors, SubmitQrPasswordResponses, SwitchCompanyData, SwitchCompanyErrors, SwitchCompanyResponses, UnlinkClientData, UnlinkClientErrors, UnlinkClientResponses, UpdateBookingData, UpdateBookingErrors, UpdateBookingResponses, UpdateChannelData, UpdateChannelErrors, UpdateChannelResponses, UpdateClientContactLabelData, UpdateClientContactLabelErrors, UpdateClientContactLabelResponses, UploadClientImportData, UploadClientImportErrors, UploadClientImportResponses, ValidateContentData, ValidateContentErrors, ValidateContentResponses, ValidateScenarioData, ValidateScenarioErrors, ValidateScenarioResponses, VoidBookingPaymentData, VoidBookingPaymentErrors, VoidBookingPaymentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Текущий пользователь и компания
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/me',
    ...options
});

/**
 * Компании пользователя
 *
 * ВСЕ компании пользователя, **включая текущую** (ту, что лежит в `Session.company`). Не «другие компании», а именно все.
 *
 * Это не придирка: поповер компаний показывает в шапке их общее число («4» в макете, строка 139), а ниже — карточку текущей компании отдельно и список «Другие компании» под ней. Верни gateway только остальные — и счётчик молча покажет «3». Список при этом выглядел бы правильным (фронт всё равно отфильтровывает текущую), так что ошибку заметили бы не сразу и искали бы долго.
 *
 * Порядок не важен: фронт сам отделяет текущую по `id`.
 */
export const listCompanies = <ThrowOnError extends boolean = false>(options?: Options<ListCompaniesData, ThrowOnError>): RequestResult<ListCompaniesResponses, ListCompaniesErrors, ThrowOnError> => (options?.client ?? client).get<ListCompaniesResponses, ListCompaniesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/me/companies',
    ...options
});

/**
 * Переключить активную компанию
 *
 * Сервер меняет компанию в сессии. Фронт после успеха чистит весь кеш.
 */
export const switchCompany = <ThrowOnError extends boolean = false>(options: Options<SwitchCompanyData, ThrowOnError>): RequestResult<SwitchCompanyResponses, SwitchCompanyErrors, ThrowOnError> => (options.client ?? client).post<SwitchCompanyResponses, SwitchCompanyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/me/companies/{companyId}/switch',
    ...options
});

export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/auth/logout',
    ...options
});

/**
 * Счётчики шапки
 *
 * Три числа для шапки: бейдж «Задачи», точка непрочитанных на «Чатах», точка на колокольчике. Шапка висит на каждом экране и опрашивается постоянно — ответ обязан быть дешёвым. Подробнее, почему это отдельная ручка, — в описании схемы Badges.
 */
export const getBadges = <ThrowOnError extends boolean = false>(options?: Options<GetBadgesData, ThrowOnError>): RequestResult<GetBadgesResponses, GetBadgesErrors, ThrowOnError> => (options?.client ?? client).get<GetBadgesResponses, GetBadgesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/badges',
    ...options
});

/**
 * Сервисы платформы Prima
 *
 * Список для переключателя сервисов в шапке — с чем ещё связана компания.
 */
export const listPlatformServices = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformServicesData, ThrowOnError>): RequestResult<ListPlatformServicesResponses, ListPlatformServicesErrors, ThrowOnError> => (options?.client ?? client).get<ListPlatformServicesResponses, ListPlatformServicesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/platform/services',
    ...options
});

/**
 * Лента уведомлений
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/notifications',
    ...options
});

/**
 * Отметить уведомления прочитанными
 *
 * С телом `{ ids: [...] }` помечает прочитанными перечисленные в `ids` уведомления. Без тела — помечает прочитанными все уведомления: именно это должно происходить, когда пользователь открывает поповер уведомлений и видит их целиком.
 */
export const markNotificationsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkNotificationsReadData, ThrowOnError>): RequestResult<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError> => (options?.client ?? client).post<MarkNotificationsReadResponses, MarkNotificationsReadErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/notifications/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Глобальный поиск по броням, клиентам и апартаментам
 */
export const search = <ThrowOnError extends boolean = false>(options: Options<SearchData, ThrowOnError>): RequestResult<SearchResponses, SearchErrors, ThrowOnError> => (options.client ?? client).get<SearchResponses, SearchErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/search',
    ...options
});

/**
 * Экран Сводки
 *
 * BFF-ручка: один запрос отдаёт весь экран целиком (приветствие, KPI, гистограмма занятости, источники брони, заезды/выезды, блок внимания). Фронт не досчитывает и не досортировывает данные — сервер уже отдал их в подающемся виде.
 */
export const getDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/dashboard',
    ...options
});

/**
 * Ось строк шахматки — апартаменты
 *
 * До 100 объектов компании. Список не зависит от диапазона дат и не меняется при горизонтальной прокрутке шахматки, поэтому это отдельная ручка от /chess/period: пересылать те же 100 объектов в каждом чанке прокрутки было бы лишней нагрузкой.
 */
export const listChessObjects = <ThrowOnError extends boolean = false>(options?: Options<ListChessObjectsData, ThrowOnError>): RequestResult<ListChessObjectsResponses, ListChessObjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListChessObjectsResponses, ListChessObjectsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/chess/objects',
    ...options
});

/**
 * Ось дней и брони шахматки за период
 *
 * Отдаёт дни диапазона (уже размеченные днём недели, флагами выходного и первого дня месяца — фронт не считает даты и не знает про локаль) и плитки броней, пересекающие диапазон. Фронт грузит период чанками при панорамировании шахматки по горизонтали; объекты (ось строк) сюда не входят — см. /chess/objects.
 */
export const getChessPeriod = <ThrowOnError extends boolean = false>(options: Options<GetChessPeriodData, ThrowOnError>): RequestResult<GetChessPeriodResponses, GetChessPeriodErrors, ThrowOnError> => (options.client ?? client).get<GetChessPeriodResponses, GetChessPeriodErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/chess/period',
    ...options
});

/**
 * Список броней
 */
export const listBookings = <ThrowOnError extends boolean = false>(options?: Options<ListBookingsData, ThrowOnError>): RequestResult<ListBookingsResponses, ListBookingsErrors, ThrowOnError> => (options?.client ?? client).get<ListBookingsResponses, ListBookingsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings',
    ...options
});

/**
 * Создать бронь
 */
export const createBooking = <ThrowOnError extends boolean = false>(options: Options<CreateBookingData, ThrowOnError>): RequestResult<CreateBookingResponses, CreateBookingErrors, ThrowOnError> => (options.client ?? client).post<CreateBookingResponses, CreateBookingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Разбивка активных броней по шагам флоу оформления
 *
 * Узкая полоса-легенда над списком броней: сколько броней сейчас стоит на каждом шаге флоу (stage — это key одного из шагов BookingDetail.flow, т.е. FlowStep.key внутри flow.steps). Бронь, у которой текущего шага нет (сценарий не начат, дошёл до конца или остановлен отменой), не считается НИГДЕ: приписать её первому шагу значило бы утверждать, что она там стоит. Отдельная ручка, а не поле в BookingList, — считается по всей компании, а не по текущей странице/фильтру списка.
 */
export const getFlowSlice = <ThrowOnError extends boolean = false>(options?: Options<GetFlowSliceData, ThrowOnError>): RequestResult<GetFlowSliceResponses, GetFlowSliceErrors, ThrowOnError> => (options?.client ?? client).get<GetFlowSliceResponses, GetFlowSliceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/flow-slice',
    ...options
});

/**
 * Карточка брони
 *
 * BFF-ручка: всё для карточки брони одним ответом — флоу оформления, платежи, клиент, требуемые действия. Фронт не собирает карточку из нескольких запросов по отдельным сущностям.
 */
export const getBooking = <ThrowOnError extends boolean = false>(options: Options<GetBookingData, ThrowOnError>): RequestResult<GetBookingResponses, GetBookingErrors, ThrowOnError> => (options.client ?? client).get<GetBookingResponses, GetBookingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}',
    ...options
});

/**
 * Изменить бронь
 *
 * Правит то немногое, что домен у брони правит: число гостей, примечание к брони и примечание к закрытому периоду. Всё остальное меняется не здесь — квартира отдельной ручкой домена, статус через действия и «вмешаться в бронь», а даты и суммы не правятся вовсе.
 *
 * ⚠️ `If-Match` ОБЯЗАТЕЛЕН: домен принимает `expected_version >= 1` и отвергает запись, если версия разошлась. Клиент кладёт сюда `BookingDetail.version` — ту, которую прочитал перед правкой. Разошлась — 409, и на экране это не «ошибка сети», а «бронь успели поменять»: перечитать и показать свежее.
 */
export const updateBooking = <ThrowOnError extends boolean = false>(options: Options<UpdateBookingData, ThrowOnError>): RequestResult<UpdateBookingResponses, UpdateBookingErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBookingResponses, UpdateBookingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Выполнить требуемое действие по брони
 *
 * Кнопка из actionsRequired брони (например «Подтвердить платёж»). Ответ — обновлённая карточка брони, actionsRequired в ней уже без выполненного пункта.
 * ⚠️ Тело ОБЯЗАТЕЛЬНО: «почему» требуется у каждого действия (3.2), и без него сервер операцию не выполнит. У действия с `needsAmount` там же приезжает сумма — её сервер выдумать не может.
 *
 * ⚠️ Ключ действия НЕ ВСЕГДА адресует шаг однозначно. При параллельных ветках бронь может стоять на ДВУХ ручных шагах с одинаковым ключом — тогда сервер отвечает `409`, и закрыть такую задачу отсюда нельзя в принципе: выбирать за менеджера, какую из двух он имел в виду, нечем. Путь для этого — очередь: `POST /tasks/{taskId}/actions/{actionKey}`, где шаг назван идентификатором задачи, а не ключом действия.
 */
export const runBookingAction = <ThrowOnError extends boolean = false>(options: Options<RunBookingActionData, ThrowOnError>): RequestResult<RunBookingActionResponses, RunBookingActionErrors, ThrowOnError> => (options.client ?? client).post<RunBookingActionResponses, RunBookingActionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/actions/{actionKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Вмешаться в ход конкретной брони
 *
 * Правка на ЖИВОЙ брони (3.2B): пропустить шаг, сменить кто подтверждает, изменить сумму, перевести на новую версию сценария, отменить. Касается ТОЛЬКО этой брони — сценарий и остальные брони не меняются.
 * ⚠️ Отказ приходит с кодом 200 и `applied: false` — это ОТВЕТ, а не ошибка (3.2B). Перевод на новую версию система вправе отклонить и объяснить причины списком; менеджер при этом ничего не сломал, и красный сбой сказал бы ему неправду. Ошибки ручки (нет причины, нет суммы, операция недоступна) — по-прежнему 4xx.
 * «Почему» обязательно у каждой правки: оно пишется в историю брони.
 */
export const runBookingIntervention = <ThrowOnError extends boolean = false>(options: Options<RunBookingInterventionData, ThrowOnError>): RequestResult<RunBookingInterventionResponses, RunBookingInterventionErrors, ThrowOnError> => (options.client ?? client).post<RunBookingInterventionResponses, RunBookingInterventionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/interventions/{interventionKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Записать платёж по брони
 *
 * Ручная запись менеджера: наличные на заселении, залог, возврат, удержанный штраф.
 *
 * Ответ — ЛЕНТА ЦЕЛИКОМ со сводом, а не добавленная строка. Так решил домен, и решение верное: после записи меняется не одна строка, а весь свод — оплаченное, залог, проценты, — и собирать новую картину из старой на клиенте значило бы держать вторую реализацию их арифметики.
 *
 * ⚠️ `Idempotency-Key` обязателен по той же причине, что у создания брони: клиент не отличает «сервер не получил» от «получил, записал, а ответ потерялся». Без ключа повтор после сбоя сети записал бы ВТОРОЙ платёж живыми деньгами.
 */
export const recordBookingPayment = <ThrowOnError extends boolean = false>(options: Options<RecordBookingPaymentData, ThrowOnError>): RequestResult<RecordBookingPaymentResponses, RecordBookingPaymentErrors, ThrowOnError> => (options.client ?? client).post<RecordBookingPaymentResponses, RecordBookingPaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/payments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отменить ошибочную запись платежа
 *
 * Отмена РУЧНОЙ записи: деньги вводит человек, человек ошибается цифрой, и без отмены опечатка осталась бы неверной суммой навсегда.
 *
 * ⚠️ ЗАПИСЬ НЕ УДАЛЯЕТСЯ, А ПОМЕЧАЕТСЯ ОТМЕНЁННОЙ. «Записали и отменили» — часть финансовой истории; в свод такие строки не входят, но со страницы не исчезают.
 *
 * ⚠️ СТРОКУ ПЛОЩАДКИ ОТМЕНИТЬ НЕЛЬЗЯ — сервер ответит 422. Отказ честный: источник истины по её строкам площадка, и наша правка была бы стёрта следующим же снапшотом. Интерфейс до этого доводить не должен: кнопка отмены рисуется только у записей с `canVoid`.
 */
export const voidBookingPayment = <ThrowOnError extends boolean = false>(options: Options<VoidBookingPaymentData, ThrowOnError>): RequestResult<VoidBookingPaymentResponses, VoidBookingPaymentErrors, ThrowOnError> => (options.client ?? client).post<VoidBookingPaymentResponses, VoidBookingPaymentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/payments/{paymentId}/void',
    ...options
});

/**
 * Что у гостя на экране прямо сейчас
 *
 * Живой экран гостя (3.3): чаты с ботом, чего ждёт бронь, что гостю доступно сейчас и кто отвечает. Отдельная ручка, а не поле карточки: состояние ЖИВОЕ и читается по требованию — тянуть его на каждое открытие карточки значило бы платить за то, что чаще всего не смотрят.
 * ⚠️ ТОЛЬКО ПРОСМОТР. Экран гостя — производная от сценария и контента, второго редактора бота нет (6.12). Текстов памяток тут не бывает: показ памятки оставил бы след в переписке ГОСТЯ.
 * ⚠️ `available: false` — «не смогли узнать», а не «бронь ничего не ждёт». Разница принципиальна: без неё сбой сервиса сценариев выглядит как пустая бронь.
 */
export const getBookingGuestScreen = <ThrowOnError extends boolean = false>(options: Options<GetBookingGuestScreenData, ThrowOnError>): RequestResult<GetBookingGuestScreenResponses, GetBookingGuestScreenErrors, ThrowOnError> => (options.client ?? client).get<GetBookingGuestScreenResponses, GetBookingGuestScreenErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/guest-screen',
    ...options
});

/**
 * Переотправить гостю ссылку на бота
 *
 * Сервер выпускает свежую персональную ссылку и САМ отправляет её в чат гостя (3.5).
 *
 * ⚠️ В ОТВЕТЕ НЕТ НИ КОДА, НИ АДРЕСА — только куда ушло и какие боты покрыты. Персональная ссылка одноразовая и привязывает к брони тот чат, который её открыл: показ ссылки менеджеру и есть перехват, потому что первое, что с ней сделают, — нажмут «проверить».
 *
 * Тела у запроса нет: что именно отправить, решает сервер. «Почему» здесь тоже не требуется — это не правка брони, а повторная доставка того, что гостю и так причиталось.
 */
export const resendGuestLink = <ThrowOnError extends boolean = false>(options: Options<ResendGuestLinkData, ThrowOnError>): RequestResult<ResendGuestLinkResponses, ResendGuestLinkErrors, ThrowOnError> => (options.client ?? client).post<ResendGuestLinkResponses, ResendGuestLinkErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/bookings/{bookingId}/guest-link/resend',
    ...options
});

/**
 * Очередь задач
 *
 * BFF-ручка: очередь того, что ждёт человека, уже сгруппирована по срочности (overdue/today/later) и отсортирована — фронт не группирует и не сортирует сам.
 *
 * ⚠️ Отбора «мои / без исполнителя» здесь НЕТ и быть не может: исполнителей в системе не существует вовсе — задачу нельзя ни назначить, ни забрать. Очередь у компании ОДНА, общая, и разбирают её сверху вниз. Пока такой отбор был, вкладка «Мои» отвечала пустотой всегда, а «Без исполнителя» повторяла «Все» — интерфейс обещал распределение работы, которого нет.
 */
export const getTaskQueue = <ThrowOnError extends boolean = false>(options?: Options<GetTaskQueueData, ThrowOnError>): RequestResult<GetTaskQueueResponses, GetTaskQueueErrors, ThrowOnError> => (options?.client ?? client).get<GetTaskQueueResponses, GetTaskQueueErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/tasks/queue',
    ...options
});

/**
 * Выполнить действие по задаче
 *
 * Закрывает задачу выбранным действием — подтвердить, отклонить, отметить выполненным, назвать сумму. Тело — то же `BookingActionRequest`, что у действия в карточке брони: ⚠️ «почему» обязательно у КАЖДОГО действия (3.2), без него сервер операцию не выполнит.
 *
 * ⚠️ ПОЧЕМУ ЭТО НЕ `POST /bookings/{id}/actions/{key}`, хотя действие принадлежит брони. У сценария бывают ПАРАЛЛЕЛЬНЫЕ ветки (1.5), а значит одна бронь может одновременно стоять на двух ручных шагах — и оба предложат, скажем, «Подтвердить». По одному ключу действия сервер не разобрал бы, какой из них закрывают; `taskId` называет шаг однозначно. Тело и семантика при этом общие намеренно: одно и то же нажатие в очереди и в карточке обязано отправлять одно и то же.
 *
 * Повторный вызов на уже разобранной задаче — не ошибка: два менеджера могут нажать одновременно, и второй получает тот же ответ. Разобранная задача пропадает из очереди, а `resolvedToday` учтёт её при следующем чтении.
 */
export const runTaskAction = <ThrowOnError extends boolean = false>(options: Options<RunTaskActionData, ThrowOnError>): RequestResult<RunTaskActionResponses, RunTaskActionErrors, ThrowOnError> => (options.client ?? client).post<RunTaskActionResponses, RunTaskActionErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/tasks/{taskId}/actions/{actionKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список переписок
 *
 * Страница списка. Ответ — конверт, а не голый массив: у списка есть продолжение (курсор) и счётчик по всей выборке, а массив не может нести ни того, ни другого.
 */
export const listConversations = <ThrowOnError extends boolean = false>(options?: Options<ListConversationsData, ThrowOnError>): RequestResult<ListConversationsResponses, ListConversationsErrors, ThrowOnError> => (options?.client ?? client).get<ListConversationsResponses, ListConversationsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations',
    ...options
});

/**
 * Непривязанные входящие («разбор»)
 *
 * Сообщения из чатов, которые система не смогла связать ни с одной бронью (3.4): канал, от кого, текст, время. Очередь наполняется сама и БЕЗ участия менеджера — в том числе его собственной кнопкой «ссылка на бота»: открытие обычной ссылки не резолвится в бронь и порождает здесь строку (3.5). Поэтому у записи два равноправных исхода, и «закрыть» — не менее частый, чем «привязать».
 */
export const listTriage = <ThrowOnError extends boolean = false>(options?: Options<ListTriageData, ThrowOnError>): RequestResult<ListTriageResponses, ListTriageErrors, ThrowOnError> => (options?.client ?? client).get<ListTriageResponses, ListTriageErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/triage',
    ...options
});

/**
 * Привязать входящее к брони
 *
 * ⚠️ НЕОБРАТИМО И ШИРЕ, ЧЕМ ВЫГЛЯДИТ: привязывается не сообщение, а ЧАТ — и с бронью навсегда (3.4). Поэтому привязывать можно только чат ГОСТЯ. Если строку породила своя же ссылка на бота, чат принадлежит менеджеру, и привязка отдала бы ему панель гостя — такие записи закрывают (см. ConversationTriageClose). Интерфейс обязан назвать это последствие ДО нажатия, а не показывать ошибку после (0.5).
 */
export const attachTriageEntry = <ThrowOnError extends boolean = false>(options: Options<AttachTriageEntryData, ThrowOnError>): RequestResult<AttachTriageEntryResponses, AttachTriageEntryErrors, ThrowOnError> => (options.client ?? client).post<AttachTriageEntryResponses, AttachTriageEntryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/triage/{entryId}/attach',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Закрыть запись разбора, не привязывая её
 *
 * Убрать строку из очереди БЕЗ привязки к брони. Это основной путь для записей, порождённых кнопкой «ссылка на бота» самого менеджера: спека называет его прямо — «её нужно закрыть, а не привязывать» (3.5).
 * ⚠️ БЕЗ ЭТОЙ ОПЕРАЦИИ ЭКРАН НЕВОЗМОЖЕН. Единственным действием осталась бы привязка, то есть очередь от собственного шума чистилась бы только тем действием, которое к этому шуму применять нельзя, — и каждая проверка «жив ли бот» оставляла бы неубираемую строку.
 */
export const closeTriageEntry = <ThrowOnError extends boolean = false>(options: Options<CloseTriageEntryData, ThrowOnError>): RequestResult<CloseTriageEntryResponses, CloseTriageEntryErrors, ThrowOnError> => (options.client ?? client).post<CloseTriageEntryResponses, CloseTriageEntryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/triage/{entryId}/close',
    ...options
});

/**
 * Карточка переписки
 *
 * BFF-ручка: шапка чата одним ответом — гость, канал, режим (менеджер/ИИ), черновик ИИ (если есть), привязанная бронь, ответственный. Лента сообщений — отдельная ручка, см. /conversations/{conversationId}/timeline.
 */
export const getConversation = <ThrowOnError extends boolean = false>(options: Options<GetConversationData, ThrowOnError>): RequestResult<GetConversationResponses, GetConversationErrors, ThrowOnError> => (options.client ?? client).get<GetConversationResponses, GetConversationErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}',
    ...options
});

/**
 * Лента переписки
 *
 * Единый поток брони, МУЛЬТИканальный: сообщения (из WhatsApp, бота, SMS, веба — у каждого свой channel), события брони, системные записи (system, с раскрываемым detail), свёрнутые технические группы (tech) и разделители дней идут вперемешку в items, уже в правильном порядке. Фронт не группирует сам — рисует список, разбирая по discriminator-полю type. У сообщения может быть attachment — рисуем строго то, что прислано.
 */
export const getConversationTimeline = <ThrowOnError extends boolean = false>(options: Options<GetConversationTimelineData, ThrowOnError>): RequestResult<GetConversationTimelineResponses, GetConversationTimelineErrors, ThrowOnError> => (options.client ?? client).get<GetConversationTimelineResponses, GetConversationTimelineErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}/timeline',
    ...options
});

/**
 * Отправить сообщение гостю
 *
 * Сообщение уходит гостю выбранным каналом (channelKind — род из ConversationDetail.sendChannels с available=true; без него сервер берёт канал по умолчанию, ConversationDetail.channel). Отправка необратима — отсюда обязательный Idempotency-Key: повтор с тем же ключом в пределах суток не продублирует сообщение гостю. В ответ приходит TimelineMessage, который фронт сразу вставляет в ленту — изначально со статусом доставки sending (deliveryStatus), дальше статус обновляется поллингом /conversations/{conversationId}/timeline.
 */
export const sendMessage = <ThrowOnError extends boolean = false>(options: Options<SendMessageData, ThrowOnError>): RequestResult<SendMessageResponses, SendMessageErrors, ThrowOnError> => (options.client ?? client).post<SendMessageResponses, SendMessageErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отправить черновик ИИ как есть
 *
 * Уходит ровно тот черновик, который видел менеджер, — `draftId`. Между чтением переписки и кликом ИИ может заменить черновик более новым, и по клику на старый не должен уйти текст, которого менеджер не читал: черновик, который больше не ждёт решения, отвечает 409, и по этому клику гостю не уходит ничего. Править черновик нельзя — для этого переписку переводят в режим manager и отправляют текст обычным sendMessage.
 *
 * Сообщение уходит тем же каналом, что sendMessage без channelKind, ложится в ленту сообщением ИИ, и дальше переписку ведёт менеджер (mode — manager).
 *
 * ⚠️ Idempotency-Key у ручки НЕТ, и это не пропуск. Черновик, который сервер отметил отправленным, второй раз не уйдёт и без него: сервер захватывает черновик перед отправкой, и повтор получает 409. После неудачной отправки (422) черновик, если его не заменили, снова ждёт, и повтор с тем же draftId отправит его заново.
 */
export const sendAiDraft = <ThrowOnError extends boolean = false>(options: Options<SendAiDraftData, ThrowOnError>): RequestResult<SendAiDraftResponses, SendAiDraftErrors, ThrowOnError> => (options.client ?? client).post<SendAiDraftResponses, SendAiDraftErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}/ai-draft/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отклонить черновик ИИ
 *
 * Отклоняется ровно тот черновик, который видел менеджер, — `draftId`: более новый, которого он не видел, этот вызов не трогает. 204 — и тогда, когда черновика с этим id среди ожидающих уже нет: отклонять нечего, и это не ошибка.
 */
export const dismissAiDraft = <ThrowOnError extends boolean = false>(options: Options<DismissAiDraftData, ThrowOnError>): RequestResult<DismissAiDraftResponses, DismissAiDraftErrors, ThrowOnError> => (options.client ?? client).post<DismissAiDraftResponses, DismissAiDraftErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}/ai-draft/dismiss',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Переключить режим переписки — менеджер/ИИ
 *
 * Переключение на manager автоматически отклоняет висящий черновик ИИ (ConversationDetail.aiDraft), если он есть, — менеджер взял диалог на себя, и предложение ИИ протухло. Переключение на ai черновик не создаёт: он появится сам, когда ответит гость.
 */
export const setConversationMode = <ThrowOnError extends boolean = false>(options: Options<SetConversationModeData, ThrowOnError>): RequestResult<SetConversationModeResponses, SetConversationModeErrors, ThrowOnError> => (options.client ?? client).post<SetConversationModeResponses, SetConversationModeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/conversations/{conversationId}/mode',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Каталог типов шага движка сценариев
 *
 * Каталог движка сценариев (catalog_json) — единственный источник истины для палитры и инспектора. Фронт НИЧЕГО не хардкодит: типы блоков (`blocks: BlockManifest[]`), их поля (`fields[]` — схема инспектора, где `field.path` = ключ в `config`), исходы, факты, события, способы оплаты, операторы и `capabilities` приходят отсюда. Значение поля пишется под `config[field.path]`, и конфиг валиден by construction — никакого params→config перевода. Доступность блока в палитре = `enabled || safeWhenDisabled`. Форма ответа — в схеме `ScenarioCatalog` (см. docs/flowengine-builder-api.md, § GetBuilderCatalog); именно её должен вернуть gateway.
 */
export const getScenarioCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetScenarioCatalogData, ThrowOnError>): RequestResult<GetScenarioCatalogResponses, GetScenarioCatalogErrors, ThrowOnError> => (options?.client ?? client).get<GetScenarioCatalogResponses, GetScenarioCatalogErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/catalog',
    ...options
});

/**
 * Список сценариев
 */
export const listScenarios = <ThrowOnError extends boolean = false>(options?: Options<ListScenariosData, ThrowOnError>): RequestResult<ListScenariosResponses, ListScenariosErrors, ThrowOnError> => (options?.client ?? client).get<ListScenariosResponses, ListScenariosErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios',
    ...options
});

/**
 * Создать пустой сценарий
 *
 * Заводит новый сценарий с именем по умолчанию и уже посаженным стартовым блоком-триггером. Совсем пустым граф быть не может: ScenarioGraph.startBlockId обязан присутствовать среди nodes, а блоки-триггеры в палитру не попадают — их сажает сервер. Тела нет: имя правится потом через PATCH /scenarios/{scenarioId}. Ответ — созданный Scenario целиком (draft, issues, readyToPublish), как у getScenario: свежий сценарий честно открывается с проблемами «дострой граф», а не «зелёным».
 */
export const createScenario = <ThrowOnError extends boolean = false>(options?: Options<CreateScenarioData, ThrowOnError>): RequestResult<CreateScenarioResponses, CreateScenarioErrors, ThrowOnError> => (options?.client ?? client).post<CreateScenarioResponses, CreateScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios',
    ...options
});

/**
 * Создать сценарий из шаблона
 */
export const createScenarioFromTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateScenarioFromTemplateData, ThrowOnError>): RequestResult<CreateScenarioFromTemplateResponses, CreateScenarioFromTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateScenarioFromTemplateResponses, CreateScenarioFromTemplateErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Удалить сценарий
 *
 * Удаляет сценарий вместе с его черновиком. Сервер сам снимает ссылки на него из маршрута: правила с ним пропадают, а `defaultTarget`, если он указывал на этот сценарий, становится `null` — «автоматизации нет». Подставлять вместо удалённого «первый попавшийся» нельзя: это увело бы все новые брони в чужой сценарий, и никто бы этого не заметил.
 */
export const deleteScenario = <ThrowOnError extends boolean = false>(options: Options<DeleteScenarioData, ThrowOnError>): RequestResult<DeleteScenarioResponses, DeleteScenarioErrors, ThrowOnError> => (options.client ?? client).delete<DeleteScenarioResponses, DeleteScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}',
    ...options
});

/**
 * Карточка сценария
 *
 * Включает текущий черновик (draft) целиком — граф узлов и связей — и issues (проблемы валидации графа, их считает сервер: он знает семантику движка, включая условия, параллельные ветки и слияния).
 */
export const getScenario = <ThrowOnError extends boolean = false>(options: Options<GetScenarioData, ThrowOnError>): RequestResult<GetScenarioResponses, GetScenarioErrors, ThrowOnError> => (options.client ?? client).get<GetScenarioResponses, GetScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}',
    ...options
});

/**
 * Переименовать сценарий
 *
 * Меняет ТОЛЬКО отображаемое имя. Граф, версия и draftVersion не трогаются — автосейв продолжает работать с тем же If-Match, конфликта версий rename не создаёт. Ответ — обновлённый Scenario.
 */
export const renameScenario = <ThrowOnError extends boolean = false>(options: Options<RenameScenarioData, ThrowOnError>): RequestResult<RenameScenarioResponses, RenameScenarioErrors, ThrowOnError> => (options.client ?? client).patch<RenameScenarioResponses, RenameScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Сохранить черновик графа (автосейв)
 *
 * Полная замена графа черновика — тело ScenarioGraph. Требует If-Match с текущим Scenario.draftVersion: сервер меняет версию на каждое сохранение, и если версия в заголовке разошлась с текущей (кто-то другой уже сохранил более новую), отвечает 409 — чужие правки не затираем. Актуальная версия в этом случае приезжает в поле currentVersion расширенной схемы 409-ответа (см. ниже) — это отдельный extension member по RFC 9457, а не Problem.detail: detail свободный текст для человека, а не поле для парсинга. По currentVersion фронт показывает конфликт и предлагает перезагрузить черновик.
 */
export const saveScenarioDraft = <ThrowOnError extends boolean = false>(options: Options<SaveScenarioDraftData, ThrowOnError>): RequestResult<SaveScenarioDraftResponses, SaveScenarioDraftErrors, ThrowOnError> => (options.client ?? client).put<SaveScenarioDraftResponses, SaveScenarioDraftErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Опубликовать черновик
 *
 * Текущий черновик (draft) становится действующей версией сценария. Ответ — обновлённый Scenario: version и status отражают новое опубликованное состояние, draft остаётся доступным для дальнейшего редактирования.
 */
export const publishScenario = <ThrowOnError extends boolean = false>(options: Options<PublishScenarioData, ThrowOnError>): RequestResult<PublishScenarioResponses, PublishScenarioErrors, ThrowOnError> => (options.client ?? client).post<PublishScenarioResponses, PublishScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}/publish',
    ...options
});

/**
 * Проверка пути по текущему черновику
 *
 * Прогоняет сценарий по шагам и показывает, каким путём пойдёт бронь (1.11). НИЧЕГО реального не происходит: сообщения не уходят, платежи не создаются, памятки не открываются, бронь не создаётся — ответ лишь перечисляет команды, которые БЫЛИ БЫ отправлены.
 * Путь по графу знает только движок (условия, параллельные ветки, слияния), поэтому фронт его не эмулирует: он задаёт начальные данные и последовательность входов, а рисует присланное.
 * ⚠️ Часов у прогона нет — сам по себе ни один срок не наступит. Но срок это такой же вход, и ответ САМ перечисляет свои сроки с готовыми подписями: интерфейсу остаётся нарисовать список и дать по нему нажать, ничего не придумывая.
 */
export const dryRunScenario = <ThrowOnError extends boolean = false>(options: Options<DryRunScenarioData, ThrowOnError>): RequestResult<DryRunScenarioResponses, DryRunScenarioErrors, ThrowOnError> => (options.client ?? client).post<DryRunScenarioResponses, DryRunScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}/dry-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Проверить черновик графа (живая валидация движком)
 *
 * Живая статическая проверка ПЕРЕДАННОГО в теле графа-черновика — без сохранения и без версий. Фронт зовёт её на каждое изменение графа (с дебаунсом), чтобы показывать проблемы сразу: пустая сумма/процент, тупики, недостижимые шаги, дубли связей и т.п. Семантику движка (условия, параллели, слияния, подключённость сервисов) знает только сервер — фронт ничего не вычисляет сам, а раскладывает готовые проблемы по местам (см. ScenarioIssue: nodeId/fieldKey/edgeId и признак «весь граф»). Тело — тот же ScenarioGraph, что уходит в автосейв; scenarioId в пути задаёт контекст (компанию, подключённые сервисы), сам граф берётся из тела, а не из сохранённого черновика.
 */
export const validateScenario = <ThrowOnError extends boolean = false>(options: Options<ValidateScenarioData, ThrowOnError>): RequestResult<ValidateScenarioResponses, ValidateScenarioErrors, ThrowOnError> => (options.client ?? client).post<ValidateScenarioResponses, ValidateScenarioErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Карта бота — что увидит гость
 *
 * Собирается сервером ИЗ ТЕКУЩЕГО ЧЕРНОВИКА сценария, поэтому не может разойтись с тем, что бот покажет на самом деле (1.12). Только просмотр: второго редактора бота нет и не будет — он разошёлся бы с реальностью молча (6.12).
 * Считается по тому же графу, что лежит в черновике, — отдельного тела запроса нет. Если в сценарии есть ошибки, ответ приходит с `assembled: false` и списком проблем: карту в таком состоянии собрать нечем, и это нормальный ответ, а не сбой.
 */
export const getScenarioBotMap = <ThrowOnError extends boolean = false>(options: Options<GetScenarioBotMapData, ThrowOnError>): RequestResult<GetScenarioBotMapResponses, GetScenarioBotMapErrors, ThrowOnError> => (options.client ?? client).get<GetScenarioBotMapResponses, GetScenarioBotMapErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenarios/{scenarioId}/bot-map',
    ...options
});

/**
 * Готовые шаблоны сценариев
 */
export const listScenarioTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListScenarioTemplatesData, ThrowOnError>): RequestResult<ListScenarioTemplatesResponses, ListScenarioTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListScenarioTemplatesResponses, ListScenarioTemplatesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/scenario-templates',
    ...options
});

/**
 * Маршрут новых броней
 *
 * Правила, по которым новая бронь получает сценарий: условие → сценарий и КОНКРЕТНАЯ его версия, проверяются по порядку сверху вниз, срабатывает первое подошедшее; `defaultTarget` — кому не подошло ни одно. Плюс `availableScenarios` — что вообще можно выбрать (только опубликованные версии) и сколько броней идёт по каждой прямо сейчас.
 */
export const getPolicy = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyData, ThrowOnError>): RequestResult<GetPolicyResponses, GetPolicyErrors, ThrowOnError> => (options?.client ?? client).get<GetPolicyResponses, GetPolicyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/policy',
    ...options
});

/**
 * Сохранить маршрут новых броней
 *
 * Полная замена правил и «всем остальным». Порядок правил сохраняется как прислан — он логика (первое подошедшее срабатывает), а не оформление. Цель каждого правила обязана указывать на ОПУБЛИКОВАННУЮ версию: черновик гостям не показывается, поэтому такой запрос отклоняется (1.13.4).
 */
export const savePolicy = <ThrowOnError extends boolean = false>(options: Options<SavePolicyData, ThrowOnError>): RequestResult<SavePolicyResponses, SavePolicyErrors, ThrowOnError> => (options.client ?? client).put<SavePolicyResponses, SavePolicyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список шаблонов контента
 *
 * Библиотека текстов: экран, где менеджер пишет, правит и вводит в работу. Без blocks — см. ContentRow (полный шаблон по одному — getContent). Без `kind` вернутся все виды (instruction|message|agreement); с `kind` — только один вид.
 *
 * ⚠️ ЭТО НЕ ИСТОЧНИК ДЛЯ ПИКЕРА В ШАГЕ СЦЕНАРИЯ — для него есть `listContentRoles`. Здесь строка — ЗАПИСЬ (кортеж kind/role/scope/apartmentId), и переопределение по квартире это отдельная запись С ТЕМ ЖЕ `role`. Шаг ссылается на роль, а какое переопределение получит гость, решается при рендере ПО КАЖДОЙ БРОНИ — значит в выборе шага квартирных записей быть не может: это варианты, которые сценарий выразить не способен. Пока пикер строился отсюда, компания с переопределением на каждой квартире видела в нём один и тот же текст столько раз, сколько у неё квартир.
 *
 * ⚠️ Не фильтровать по `status == published` и не адресовать строку по `version`: `id` называет ту запись, которую менеджер ОТКРЫВАЕТ, — черновик, если он есть, иначе рабочую версию.
 */
export const listContent = <ThrowOnError extends boolean = false>(options?: Options<ListContentData, ThrowOnError>): RequestResult<ListContentResponses, ListContentErrors, ThrowOnError> => (options?.client ?? client).get<ListContentResponses, ListContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content',
    ...options
});

/**
 * Создать шаблон контента
 *
 * Заводит новый шаблон-черновик выбранного вида (kind) с пустым телом. Форма домена одна (blocks[]), поэтому редактор/превью/сохранение у всех видов общие. Блоки автор правит сразу в редакторе (PUT saveContent). Без тела/поля kind создаётся instruction. Ответ — ContentItem.
 *
 * ⚠️ ТЕКСТ ЗАВОДИТСЯ ПО НАЗВАНИЮ, идентификатор мнёт СЕРВЕР. Название гость читает на кнопке в боте, а идентификатор не должен видеть никто (2.2) — спрашивать его при создании значило бы начинать работу с поля, смысл которого менеджеру объяснить нельзя. Разницы между «создать памятку Wi-Fi из готовых» и «создать новую и назвать Wi-Fi» нет никакой (2.1): в обоих случаях приходит title, во втором дополнительно приходит role готовой памятки.
 */
export const createContent = <ThrowOnError extends boolean = false>(options?: Options<CreateContentData, ThrowOnError>): RequestResult<CreateContentResponses, CreateContentErrors, ThrowOnError> => (options?.client ?? client).post<CreateContentResponses, CreateContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Каталог авторинга контента
 *
 * Единственный источник для палитры подстановок (факты · переменные квартиры · секреты · ссылки) и пикера ролей. Аналог GET /scenarios/catalog: фронт ничего не хардкодит — какие токены и роли существуют, знает сервер. Новый ключ или роль не требуют деплоя фронта.
 */
export const getContentAuthoringCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetContentAuthoringCatalogData, ThrowOnError>): RequestResult<GetContentAuthoringCatalogResponses, GetContentAuthoringCatalogErrors, ThrowOnError> => (options?.client ?? client).get<GetContentAuthoringCatalogResponses, GetContentAuthoringCatalogErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/authoring-catalog',
    ...options
});

/**
 * На что может сослаться шаг сценария
 *
 * Роли выбранного вида — ОДНА запись на роль, независимо от того, сколько у неё версий и квартирных переопределений. Это единственный источник для пикера текста в шаге сценария.
 * Вопрос здесь другой, чем у `listContent`, и путать их нельзя. Библиотека отвечает «какие тексты есть у компании» (там правят и вводят в работу, там же живут переопределения по квартирам). Эта ручка отвечает «на что может сослаться ШАГ» — а шаг знает только роль: версию и квартирное переопределение выбирает рендер по каждой брони.
 *
 * ⚠️ И это НЕ `ContentAuthoringCatalog.roles`. Там — «что можно СОЗДАТЬ» (встроенные роли, в том числе те, по которым ещё ничего не написано). Здесь — «на что можно СОСЛАТЬСЯ» с признаками пригодности. Разные вопросы: первый нужен при заведении текста, второй — при выборе в шаге.
 *
 * Квартиры параметром НЕТ намеренно. Сценарий общий для компании, и роль, опубликованная только как переопределение одной квартиры, для всех остальных действительно отсутствует — она и должна прийти как `published: false`. Параметр появится, если заведём экран «а что получит гость ИМЕННО этой квартиры»; сейчас такого вопроса не задаёт ни один экран.
 */
export const listContentRoles = <ThrowOnError extends boolean = false>(options: Options<ListContentRolesData, ThrowOnError>): RequestResult<ListContentRolesResponses, ListContentRolesErrors, ThrowOnError> => (options.client ?? client).get<ListContentRolesResponses, ListContentRolesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/roles',
    ...options
});

/**
 * Пригодны ли роли, на которые ссылается сценарий
 *
 * Ответ на вопрос «можно ли положиться на текст, к которому ведёт шаг» — для ролей, которые спрашивающий уже знает. Считается ТОЙ ЖЕ функцией, что и `listContentRoles`: выбор в шаге не должен предлагать то, что проверка потом отвергнет, а два независимых ответа на один вопрос однажды разойдутся. Это и есть причина, по которой ручка отдельная, а не «посчитайте сами по библиотеке»: библиотека отвечает про ЗАПИСИ, а шаг ссылается на РОЛЬ.
 * Соединять с разбором сценария по `role` и вешать ответ на шаг — так «этот шаг открывает памятку, которой нет» доходит до менеджера раньше, чем гость нажмёт кнопку.
 *
 * POST при том, что это чтение: ролей бывает до 500, и в строке запроса им тесно. Тот же приём, что у проверки графа сценария.
 *
 * Квартиры в запросе НЕТ намеренно — по той же причине, что и у `listContentRoles`: сценарий общий для компании, и роль, введённая в работу только переопределением одной квартиры, для всех остальных броней действительно отсутствует. Спросить «а что получит гость ИМЕННО этой квартиры» — другой вопрос, и такого экрана у нас пока нет.
 */
export const listContentRoleStatus = <ThrowOnError extends boolean = false>(options: Options<ListContentRoleStatusData, ThrowOnError>): RequestResult<ListContentRoleStatusResponses, ListContentRoleStatusErrors, ThrowOnError> => (options.client ?? client).post<ListContentRoleStatusResponses, ListContentRoleStatusErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/role-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Удалить текст
 *
 * Сносит запись целиком и сразу — черновик и все её версии, без дрейна. Шаг сценария, ссылавшийся на эту роль, останется с висящей ссылкой: гость нажмёт кнопку, которая ничего не откроет.
 *
 * ⚠️ РАДИУС ЗАВИСИТ ОТ ОБЛАСТИ ЗАПИСИ, и это не тонкость, а два разных действия интерфейса. Удаление ОБЩЕЙ записи сносит роль у компании ЦЕЛИКОМ — вместе со своими текстами квартир: оставить их значило бы, что менеджер удалил текст, а гости нескольких квартир продолжают его получать. Удаление записи КВАРТИРЫ снимает только её — квартира возвращается к общему тексту («убрать свой текст квартиры»), и на остальные это не влияет.
 *
 * Прежняя формулировка («сносит всю роль») описывала только первый случай, и второй под неё не подпадал вовсе — то есть операция «убрать свой текст квартиры» контрактом не выражалась.
 */
export const deleteContent = <ThrowOnError extends boolean = false>(options: Options<DeleteContentData, ThrowOnError>): RequestResult<DeleteContentResponses, DeleteContentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContentResponses, DeleteContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}',
    ...options
});

/**
 * Карточка шаблона контента
 *
 * Полный текст с частями, проверками (issues) и списком мест, откуда он попадает гостю (usage). ⚠️ Ошибки из issues БЛОКИРУЮТ ввод в работу; предупреждения — нет.
 */
export const getContent = <ThrowOnError extends boolean = false>(options: Options<GetContentData, ThrowOnError>): RequestResult<GetContentResponses, GetContentErrors, ThrowOnError> => (options.client ?? client).get<GetContentResponses, GetContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}',
    ...options
});

/**
 * Сохранить черновик текста
 *
 * Полная замена тела (upsert черновика). ⚠️ Сохранение НЕ ПРОВЕРЯЕТ НИЧЕГО (2.4) — черновик можно оставить в любом состоянии; проверки выполняются при вводе в работу. Пересчитанные issues в ответе приходят как подсказка автору, а не как условие сохранения.
 * Клиент возвращает `revision` таким, каким прочитал (6.10).
 *
 * ⚠️ ЭТО PUT ЦЕЛОГО ДОКУМЕНТА, И ЧАСТИЧНОЕ ТЕЛО — НЕ «НЕ ТРОГАТЬ ОСТАЛЬНОЕ», А ОТКАЗ. `blocks` — обязательное поле `ContentDocument`, поэтому тело без него невалидно по контракту, и применять его нельзя НИ КАК полную замену (это молча стёрло бы весь текст), НИ КАК частичную правку (такой семантики у операции нет). Правильный ответ — `422`, до записи.
 *
 * ⚠️ ТЕЛО — `ContentDocument`, А ОТВЕТ — `ContentItem`, И РАЗВЕЛИ ИХ НЕ ДЛЯ ПОРЯДКА. Из полей ответа СЕМЬ приставляются на выходе и на документе их нет вовсе, а `status` и `version` на документе есть, но принадлежат серверу: сохранение затирает присланное. Разбор — у самой схемы. Пока схема была ОДНА, контракт формально требовал прислать в теле русскую ФРАЗУ `deliveryLabel` — то есть завести ровно тот приватный словарь, ради сноса которого поле и просили.
 * Клиент по-прежнему шлёт документ таким, каким прочитал, и выводные поля в теле оказываются: лишние свойства схема не запрещает. Но теперь это ЕГО дело, а не требование контракта, — и первый же путь, собирающий тело не из прочитанной записи, ни во что не упрётся.
 * Отдельной ручки «дописать блок» нет намеренно: порядок блоков — часть смысла текста, и частичные правки поверх чужого порядка расходятся молча. Интерфейс всегда шлёт документ целиком — тем самым, каким его прочитал.
 */
export const saveContent = <ThrowOnError extends boolean = false>(options: Options<SaveContentData, ThrowOnError>): RequestResult<SaveContentResponses, SaveContentErrors, ThrowOnError> => (options.client ?? client).put<SaveContentResponses, SaveContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ввести текст в работу
 *
 * Переводит черновик в рабочее состояние — то, что получает гость. ⚠️ НЕ создаёт копию и НЕ меняет номер версии (2.4): меняется состояние записи. Следующая правка заведёт новый черновик, а рабочая версия останется жить — и гость будет получать её, пока новый черновик не введут в работу.
 * ⚠️ Блокируют ТОЛЬКО ошибки. Предупреждения приходят ВМЕСТЕ с успешным ответом, а не вместо него: иначе их не увидел бы никто.
 * Что НЕ проверяется и спокойно вводится в работу (2.4): пустая ТЕКСТОВАЯ часть, неправильные адреса ссылок, отсутствие названия и идентификатора — гость получит «Здесь пока пусто.» Отсутствие частей вовсе при этом проверкой является и вводу в работу мешает.
 * ⚠️ Требует `revision` — тот, что клиент прочитал (6.10). Без него один менеджер показал бы гостям черновик, который писал другой и ещё не считает готовым: правка ушла бы наружу, а увидели бы её только гости.
 */
export const publishContent = <ThrowOnError extends boolean = false>(options: Options<PublishContentData, ThrowOnError>): RequestResult<PublishContentResponses, PublishContentErrors, ThrowOnError> => (options.client ?? client).post<PublishContentResponses, PublishContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Превью шаблона под канал
 *
 * Рендерит сервер под конкретный канал — он знает правила leak-safe (секреты в SMS уходят только ссылкой, не значением) и подстановку токенов. Текст приходит сегментами; фронт не собирает превью сам из blocks.
 *
 * ⚠️ ПОЧЕМУ POST, ЕСЛИ ЭТО ЧТЕНИЕ. Потому что превью обязано отвечать про то, что автор пишет СЕЙЧАС, а несохранённое тело помещается только в тело запроса. Пока ручка была `GET` по идентификатору, и рендер, и замечания описывали ПОСЛЕДНЕЕ СОХРАНЁННОЕ состояние: про слишком длинный ключ критерия автор узнавал уже после «Сохранить», а превью рядом показывало вчерашний текст. Запрос ничего не записывает — `draft` это вход рендера, а не правка записи.
 *
 * ⚠️ ИДЕНТИФИКАТОР ОСТАЁТСЯ В ПУТИ И ОСТАЁТСЯ ОБЯЗАТЕЛЬНЫМ, даже когда тело прислано целиком. Рендер зависит не только от частей: вид, роль, область и природа доставки берутся из ЗАПИСИ — по ним решается, чем становится ссылка, какие каналы у текста есть вообще и подставлять ли данные квартиры. Ручка «только тело, без записи» отрендерить не смогла бы.
 */
export const previewContent = <ThrowOnError extends boolean = false>(options: Options<PreviewContentData, ThrowOnError>): RequestResult<PreviewContentResponses, PreviewContentErrors, ThrowOnError> => (options.client ?? client).post<PreviewContentResponses, PreviewContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Проверить набранное тело — без рендера
 *
 * Отвечает только замечаниями. Ничего не рисует и ничего не записывает: `draft` — вход проверки, а не правка записи.
 *
 * ⚠️ ЗАЧЕМ ОТДЕЛЬНАЯ РУЧКА, ЕСЛИ ЗАМЕЧАНИЯ ЕСТЬ У ПРЕВЬЮ. Потому что превью требует поверхность — оно про картинку. Редактору картинка не нужна, ему нужен список; спрашивая превью, он заставлял сервер рендерить в никуда и вдобавок выбирать канал там, где канал ни на что не влияет (замечания по каналу не фильтруются). Домен предложил именно эту форму: «сделать `channel` необязательным нельзя — пустая строка там уже занята историческим веб-умолчанием, и „не рендерить" сказать нечем».
 *
 * ⚠️ ИДЕНТИФИКАТОР В ПУТИ ОБЯЗАТЕЛЕН, как и у превью: `kind`, `role` и `scope` читают сами проверки, и берутся они из ЗАПИСИ. Разбор — в `ContentDraft`.
 */
export const validateContent = <ThrowOnError extends boolean = false>(options: Options<ValidateContentData, ThrowOnError>): RequestResult<ValidateContentResponses, ValidateContentErrors, ThrowOnError> => (options.client ?? client).post<ValidateContentResponses, ValidateContentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/content/{contentId}/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Настройки бренда
 */
export const getBrand = <ThrowOnError extends boolean = false>(options?: Options<GetBrandData, ThrowOnError>): RequestResult<GetBrandResponses, GetBrandErrors, ThrowOnError> => (options?.client ?? client).get<GetBrandResponses, GetBrandErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/brand',
    ...options
});

/**
 * Сохранить настройки бренда
 */
export const saveBrand = <ThrowOnError extends boolean = false>(options: Options<SaveBrandData, ThrowOnError>): RequestResult<SaveBrandResponses, SaveBrandErrors, ThrowOnError> => (options.client ?? client).put<SaveBrandResponses, SaveBrandErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/brand',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список апартаментов
 *
 * Без attrs — см. ApartmentRow. Полная карточка — getApartment.
 */
export const listApartments = <ThrowOnError extends boolean = false>(options?: Options<ListApartmentsData, ThrowOnError>): RequestResult<ListApartmentsResponses, ListApartmentsErrors, ThrowOnError> => (options?.client ?? client).get<ListApartmentsResponses, ListApartmentsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments',
    ...options
});

/**
 * Роли инструкций, которыми закрыты коды доступа
 *
 * Какие роли служат ЗАМКОМ для кодов доступа. Нужно РЕДАКТОРУ СЦЕНАРИЯ: меняя роль у шага «Открыть инструкцию», автор меняет и то, кому придёт код, — и ни один экран об этом сегодня не говорит (ответ бекенда 23.08, §4; у них это `ListGatedRoles`).
 *
 * ⚠️ ЗАПРОС ПУСТОЙ, И ЭТО ОБЯЗАТЕЛЬНО. У них в прото первым полем идёт `company_id`; НАМ ЕГО СЛАТЬ НЕЛЬЗЯ И В КОНТРАКТЕ ЕГО БЫТЬ НЕ ДОЛЖНО — компанию ставит шлюз из сессии менеджера, он же и проверяет право. Появись это поле здесь, стало бы возможно спросить чужую компанию: сервис ему поверит, потому что проверку делает не он.
 *
 * ⚠️ ОТДЕЛЬНАЯ РУЧКА, А НЕ ПОЛЕ В КАТАЛОГЕ СЦЕНАРИЕВ. Каталог кешируется и меняется при деплое движка, а этот список меняется, когда менеджер заводит секрет, — то есть на другой частоте и в другом разделе. Спрятав его в каталог, мы получили бы предупреждение, отстающее ровно настолько, насколько живёт кеш.
 */
export const listGatedRoles = <ThrowOnError extends boolean = false>(options?: Options<ListGatedRolesData, ThrowOnError>): RequestResult<ListGatedRolesResponses, ListGatedRolesErrors, ThrowOnError> => (options?.client ?? client).get<ListGatedRolesResponses, ListGatedRolesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments/gated-roles',
    ...options
});

/**
 * Карточка апартамента
 *
 * secrets содержит только факт наличия (isSet) и подпись последней выдачи (lastRevealLabel) по каждому ключу — значения секретов сюда не попадают никогда, и отдельной операции «показать» тоже нет: см. банер над ApartmentSecretEntry.
 */
export const getApartment = <ThrowOnError extends boolean = false>(options: Options<GetApartmentData, ThrowOnError>): RequestResult<GetApartmentResponses, GetApartmentErrors, ThrowOnError> => (options.client ?? client).get<GetApartmentResponses, GetApartmentErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments/{apartmentId}',
    ...options
});

/**
 * Переименовать секрет апартамента
 *
 * Меняет ТОЛЬКО человеческое название секрета. Значение не трогает, версию не двигает (ничего не проворачивалось), и `requiredRole` здесь НЕТ намеренно.
 *
 * ⚠️ ОТДЕЛЬНАЯ ОПЕРАЦИЯ, А НЕ ПОЛЕ В `PUT` — И ДОВОД ЗДЕСЬ НЕ ПРО ОПРЯТНОСТЬ. Название и значение задавались одним вызовом, и от этого обычная правка становилась опасной: значение не возвращается никогда, поэтому форма правки открывается ПУСТОЙ и всё набранное ЗАМЕНЯЕТ код. Чтобы исправить опечатку в НАЗВАНИИ, менеджеру приходилось вслепую перенабирать код от двери по памяти — и промах запирал гостя снаружи. Их слова: «a punishment for a spelling mistake».
 *
 * ⚠️ `requiredRole` СЮДА НЕ КЛАДЁМ по той же причине, по какой его нет у них: это сам замок. Менять, кому и когда открывается код, — намеренное действие с последствиями для доступа, а не побочный эффект наведения порядка в подписях.
 *
 * Создать секрет этим вызовом нельзя: переименовывают существующее, а для создания нужно значение, которого запрос не несёт. Нет такого секрета — `404`.
 */
export const setApartmentSecretLabel = <ThrowOnError extends boolean = false>(options: Options<SetApartmentSecretLabelData, ThrowOnError>): RequestResult<SetApartmentSecretLabelResponses, SetApartmentSecretLabelErrors, ThrowOnError> => (options.client ?? client).patch<SetApartmentSecretLabelResponses, SetApartmentSecretLabelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments/{apartmentId}/secrets/{secretKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Задать значение секрета апартамента
 *
 * Записывает значение — само значение в ответе не возвращается, и прочитать его потом тоже нельзя (2.9): запись здесь ОДНОСТОРОННЯЯ. Значит новое значение всегда ЗАМЕНЯЕТ прежнее вслепую, и интерфейс обязан сказать об этом до нажатия, а не показывать пустое поле как «сейчас пусто». Тело — одна из двух форм: value для одиночного секрета (код замка, код сейфа), fields для структурного (Wi-Fi — сразу оба под-поля, ssid и password).
 */
export const saveApartmentSecret = <ThrowOnError extends boolean = false>(options: Options<SaveApartmentSecretData, ThrowOnError>): RequestResult<SaveApartmentSecretResponses, SaveApartmentSecretErrors, ThrowOnError> => (options.client ?? client).put<SaveApartmentSecretResponses, SaveApartmentSecretErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments/{apartmentId}/secrets/{secretKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Записать значения переменных квартиры
 *
 * Тело — карта «ключ переменной → новое значение». **Слияние, а не замена**: переданные ключи создаются или обновляются, остальные переменные этой квартиры остаются нетронутыми. Замена молча стёрла бы все незатронутые переменные квартиры — а из формы UI это выглядело бы как «я поправил адрес», и остальные данные незаметно пропали бы.
 * Отдельной ручки «создать ключ» нет: ключ появляется неявно, как только для какой-нибудь квартиры записано его значение — этим же вызовом (см. банер над ApartmentVariableEntry в components/schemas/apartment.yaml). Одна операция покрывает оба действия макета: «Изменить» у существующей переменной (один ключ в карте) и «+ добавить переменную» (новый ключ — он появится и в GET /apartment-variables). Это ровно бекенд-примитив SetApartmentVariables(apartmentId, map).
 * 404 означает только «нет такой квартиры»: ключ отдельной сущностью не является и создаётся этим же вызовом, поэтому «ключ не найден» здесь невозможен.
 */
export const setApartmentVariables = <ThrowOnError extends boolean = false>(options: Options<SetApartmentVariablesData, ThrowOnError>): RequestResult<SetApartmentVariablesResponses, SetApartmentVariablesErrors, ThrowOnError> => (options.client ?? client).patch<SetApartmentVariablesResponses, SetApartmentVariablesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartments/{apartmentId}/variables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Данные квартир матрицей «квартиры × названия»
 *
 * ⚠️ ОТДАЁТ МАТРИЦУ, А НЕ ПЛОСКИЙ СПИСОК КЛЮЧЕЙ, и это несущее решение раздела. §2.10 называет ответ прямым текстом: «матричный вид (квартиры × данные) с видимыми пробелами — самое полезное, что здесь может сделать интерфейс». Полезен он потому, что названия общие для компании ЛИШЬ НЕЯВНО: название существует, пока хотя бы у одной квартиры есть по нему значение. Значит опечатка («этаж» против «Этаж») заводит отдельное данное у одной квартиры и молча ломает вставку у всех остальных — увидеть это можно ТОЛЬКО рядом, в одной таблице.
 *
 * Собрать матрицу на клиенте нельзя: значения лежат в карточке квартиры (GET /apartments/{id}), то есть таблица стоила бы по запросу на каждую квартиру. Ключи при этом отдельной ручкой больше не нужны — это `keys` этого же ответа, и второй способ их узнать однажды разошёлся бы с первым.
 */
export const getApartmentVariableMatrix = <ThrowOnError extends boolean = false>(options?: Options<GetApartmentVariableMatrixData, ThrowOnError>): RequestResult<GetApartmentVariableMatrixResponses, GetApartmentVariableMatrixErrors, ThrowOnError> => (options?.client ?? client).get<GetApartmentVariableMatrixResponses, GetApartmentVariableMatrixErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartment-variables',
    ...options
});

/**
 * Удалить переменную у всех квартир компании
 *
 * РАЗРУШИТЕЛЬНАЯ операция на всю компанию. Снимает значение ключа у всех квартир за один вызов; после неё ключ исчезает и из GET /apartment-variables, и из палитры токенов GET /content/tokens — ровно по семантике distinct-списка (ключ существует, пока хотя бы у одной квартиры есть значение).
 *
 * Зачем она нужна. Ключи заводятся неявно — записью значения, в том числе импортом таблицы. Значит опечатка в заголовке колонки («парковкa» с латинской «a») заводит мусорный ключ, который иначе торчал бы на экране КАЖДОЙ квартиры (мы показываем объединение всех ключей компании) и в палитре токенов. Навсегда. Это ручка «исправить опечатку в импорте».
 *
 * ВНИМАНИЕ, гостевые последствия. Если на `{{apartment.<key>}}` ссылается хотя бы одна инструкция, после удаления гость увидит в ней `[[unresolved:apartment.<key>]]` вместо текста. Фронт ОБЯЗАН предупредить об этом в диалоге подтверждения и назвать радиус поражения числом — сколько квартир потеряют значение. Молча выполнять нельзя: связь между «менеджер убрал опечатку» и «у гостя сломалась инструкция» никто потом не установит.
 *
 * Бекенд-примитив: DeleteApartmentVariableKey(key), компания берётся из сессии.
 */
export const deleteApartmentVariableKey = <ThrowOnError extends boolean = false>(options: Options<DeleteApartmentVariableKeyData, ThrowOnError>): RequestResult<DeleteApartmentVariableKeyResponses, DeleteApartmentVariableKeyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApartmentVariableKeyResponses, DeleteApartmentVariableKeyErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartment-variables/{variableKey}',
    ...options
});

/**
 * Заполнить одно данное сразу у нескольких квартир
 *
 * Пишет ОДНО название сразу многим квартирам — то, что человек делает в виде «Заполнение»: столбец «код домофона» заполняется по всем объектам за один заход.
 *
 * ⚠️ Почему это отдельная ручка, а не N вызовов PATCH /apartments/{id}/variables. Записать столбец поквартирно можно, но тогда обрыв связи на середине оставляет ПОЛОВИНУ столбца записанной, и сказать менеджеру, какие строки доехали, клиенту нечем — он видит одну общую ошибку. Здесь ответ один, и он же говорит, сколько квартир изменилось. Это тот же довод, по которому матрица читается одним запросом, а не по запросу на квартиру (см. GET выше).
 *
 * Семантика значения — ровно как у поквартирной записи: строка это значение, пустая строка это ЗНАЧЕНИЕ «пусто», а `null` стирает данное у этой квартиры. Квартиры, которых нет в `values`, не трогаются вовсе — заполнение одного столбца не должно задевать соседние.
 *
 * Ключ, которого у компании ещё нет, эта же операция и заводит — неявно, как и поквартирная запись (см. банер над ApartmentVariableEntry): отдельной ручки «создать название» нет, и попап «Новое данное» в интерфейсе — это просто заполнение нового ключа.
 */
export const fillApartmentVariable = <ThrowOnError extends boolean = false>(options: Options<FillApartmentVariableData, ThrowOnError>): RequestResult<FillApartmentVariableResponses, FillApartmentVariableErrors, ThrowOnError> => (options.client ?? client).patch<FillApartmentVariableResponses, FillApartmentVariableErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartment-variables/{variableKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Импорт значений переменных квартир из таблицы
 *
 * Массовая заливка матрицы «квартира × переменные» одним файлом — быстрее, чем вызывать setApartmentVariables по каждой квартире отдельно. Формат и разбор файла — на сервере. Новую колонку таблицы импорт заводит как новый ключ автоматически — так же неявно, как и setApartmentVariables (см. банер над ApartmentVariableEntry в components/schemas/apartment.yaml); список таких новых ключей считает импортёр (gateway), см. ApartmentVariablesImportSummary.newKeys. Построчные ошибки (например, квартира не найдена) не блокируют остальной файл: они попадают в errors сводки, а корректные строки применяются — но это только для проблем внутри читаемого файла, см. 400 ниже.
 */
export const importApartmentVariables = <ThrowOnError extends boolean = false>(options: Options<ImportApartmentVariablesData, ThrowOnError>): RequestResult<ImportApartmentVariablesResponses, ImportApartmentVariablesErrors, ThrowOnError> => (options.client ?? client).post<ImportApartmentVariablesResponses, ImportApartmentVariablesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/apartment-variables/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * База гостей компании
 *
 * Гости, у которых есть живая связь с моей компанией (§2.1). Сортировка — по последнему подтверждению связи, DESC.
 * **Два независимых фильтра, комбинируются.** `name` — подстрока по ЛЮБОМУ варианту написания: «Наталья» найдёт гостя, который отображается как «Natalia Dabizha», если оба варианта записаны; регистр и пунктуация не важны («петров и в» находит «Петров И.В.»).
 * ⚠️ `phone` — ТОЛЬКО ТОЧНОЕ СОВПАДЕНИЕ ЦЕЛИКОМ. Половина номера не найдёт ничего, и придёт пустой список БЕЗ ошибки — телефоны в базе зашифрованы, поиск по подстроке технически невозможен (§4). Интерфейс обязан сказать это ДО поиска, иначе менеджер решит, что база пуста.
 */
export const listClients = <ThrowOnError extends boolean = false>(options?: Options<ListClientsData, ThrowOnError>): RequestResult<ListClientsResponses, ListClientsErrors, ThrowOnError> => (options?.client ?? client).get<ListClientsResponses, ListClientsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients',
    ...options
});

/**
 * Справочник для форм гостя
 *
 * Только то, где интерфейс ПРЕДЛАГАЕТ выбор (виды каналов в форме добавления). Для показа каталог не нужен — подписи приходят рядом со значениями.
 */
export const getClientCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetClientCatalogData, ThrowOnError>): RequestResult<GetClientCatalogResponses, GetClientCatalogErrors, ThrowOnError> => (options?.client ?? client).get<GetClientCatalogResponses, GetClientCatalogErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/catalog',
    ...options
});

/**
 * Сводка по базе гостей
 *
 * Весь экран сводки ОДНИМ запросом: все пять агрегатов считаются по одной и той же базе, и отдельных ручек под блоки нет и не нужно.
 * Параметров нет намеренно. Компания берётся из сессии — поля `companyId` в запросе нет, чтобы сводку по чужой базе нельзя было даже попросить — то же правило, что у остальных ручек гостей. ⚠️ Оно НЕСУЩЕЕ, а не стилевое: `companyId` и `actorUserId` в запросе сделали бы возможным действие от имени чужой компании: clients-service не проверяет права и доверяет присланному, а ставит их шлюз из сессии. (Спеки гостевого раздела удалены как неактуальные — правило живёт здесь и в тестах.) Фильтров по датам тоже нет: окна фиксированы (7/30/90 дней).
 * Пустая база — НЕ ошибка: придёт `200` с нулями, пустыми массивами и без `firstGuestAt` / `lastActivityAt`. Отдельного кода ответа под «нет данных» не будет.
 */
export const getClientsSummary = <ThrowOnError extends boolean = false>(options?: Options<GetClientsSummaryData, ThrowOnError>): RequestResult<GetClientsSummaryResponses, GetClientsSummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetClientsSummaryResponses, GetClientsSummaryErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/summary',
    ...options
});

/**
 * Карточка гостя
 *
 * Одна карточка на два экрана — в брони и в разделе «Гости». Прежняя узкая ручка карточки (`GetClientCard` у гейтвея) не несла ни атрибуции, ни вариантов имени, ни компаний; здесь полная форма, гейтвей маппит её на `ClientsService.GetClient` (§3).
 * `stats` и `history` — склейка с bookings-service и потому необязательны: clients-service броней не знает (§1).
 */
export const getClient = <ThrowOnError extends boolean = false>(options: Options<GetClientData, ThrowOnError>): RequestResult<GetClientResponses, GetClientErrors, ThrowOnError> => (options.client ?? client).get<GetClientResponses, GetClientErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}',
    ...options
});

/**
 * Убрать гостя из базы компании
 *
 * ⚠️ ЭТО НЕ УДАЛЕНИЕ ГОСТЯ. Снимается связь с моей компанией: гость пропадает из моего списка, но остаётся в базах других компаний, и если снова забронирует у меня — вернётся автоматически (§5). Формулировка в интерфейсе — «Убрать из базы», не «Удалить гостя».
 */
export const unlinkClient = <ThrowOnError extends boolean = false>(options: Options<UnlinkClientData, ThrowOnError>): RequestResult<UnlinkClientResponses, UnlinkClientErrors, ThrowOnError> => (options.client ?? client).delete<UnlinkClientResponses, UnlinkClientErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/link',
    ...options
});

/**
 * Добавить каналы связи
 *
 * Батчевая: тело — массив (§5). Ответ 200 даже при отказе по отдельным каналам — результат читается построчно, см. ClientContactsAddResult.
 */
export const addClientContacts = <ThrowOnError extends boolean = false>(options: Options<AddClientContactsData, ThrowOnError>): RequestResult<AddClientContactsResponses, AddClientContactsErrors, ThrowOnError> => (options.client ?? client).post<AddClientContactsResponses, AddClientContactsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Убрать канал из данных компании
 *
 * Снимает претензию МОЕЙ компании. Канал остаётся в карточке, если его заявляет кто-то ещё — об этом говорит `channelRetired: false`, и строку в этом случае убирать НЕЛЬЗЯ (§5).
 */
export const removeClientContact = <ThrowOnError extends boolean = false>(options: Options<RemoveClientContactData, ThrowOnError>): RequestResult<RemoveClientContactResponses, RemoveClientContactErrors, ThrowOnError> => (options.client ?? client).delete<RemoveClientContactResponses, RemoveClientContactErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/contacts/{identityId}',
    ...options
});

/**
 * Изменить метку канала
 *
 * Метка — ЕДИНСТВЕННОЕ, что у канала правится. Значения канала операции правки нет и не будет (§2.5): неправильный номер удаляют и добавляют правильный.
 * Только свой канал. Чужой вернёт 422 — но до этого доходить не должно, кнопка обязана быть неактивной по `ClientContact.editable` (§10).
 */
export const updateClientContactLabel = <ThrowOnError extends boolean = false>(options: Options<UpdateClientContactLabelData, ThrowOnError>): RequestResult<UpdateClientContactLabelResponses, UpdateClientContactLabelErrors, ThrowOnError> => (options.client ?? client).patch<UpdateClientContactLabelResponses, UpdateClientContactLabelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/contacts/{identityId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Добавить вариант имени
 *
 * Имя не заменяется, а ДОПОЛНЯЕТСЯ (§2.4). Удаления варианта нет вовсе (§11) — ошиблись, добавьте правильный и сделайте основным.
 */
export const addClientName = <ThrowOnError extends boolean = false>(options: Options<AddClientNameData, ThrowOnError>): RequestResult<AddClientNameResponses, AddClientNameErrors, ThrowOnError> => (options.client ?? client).post<AddClientNameResponses, AddClientNameErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/names',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Сделать вариант имени основным
 *
 * Основной вариант виден в списках и на кнопках — он же уезжает в шапку карточки.
 */
export const setClientDisplayName = <ThrowOnError extends boolean = false>(options: Options<SetClientDisplayNameData, ThrowOnError>): RequestResult<SetClientDisplayNameResponses, SetClientDisplayNameErrors, ThrowOnError> => (options.client ?? client).put<SetClientDisplayNameResponses, SetClientDisplayNameErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/clients/{clientId}/names/display',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Загрузить файл базы гостей (фаза 1 — отчёт)
 *
 * Разбирает `.xlsx` и отвечает ОТЧЁТОМ. ⚠️ НИЧЕГО НЕ ЗАПИСЫВАЕТ: гости появятся только после `commitClientImport`. Колонки сервер определяет по заголовку, порядок не важен (имя — «Имя»/«ФИО»/«Гость»/«Клиент»/«Name», телефон — «Телефон»/«Тел»/«Номер»/«Phone», почта — «Почта»/«Email»/«E-mail»); прочие колонки сохраняются справочно и в данные гостя не превращаются. Разбор целиком на сервере — своего парсера у фронта нет и быть не должно.
 */
export const uploadClientImport = <ThrowOnError extends boolean = false>(options: Options<UploadClientImportData, ThrowOnError>): RequestResult<UploadClientImportResponses, UploadClientImportErrors, ThrowOnError> => (options.client ?? client).post<UploadClientImportResponses, UploadClientImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/client-imports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Состояние загрузки
 *
 * Тот же отчёт, перечитанный. ⚠️ Ради ЭТОЙ ручки существует опрос: commit возвращается сразу, и ход применения виден только здесь — счётчики rowsCreated/rowsMatched сервер обновляет раз в 200 строк. Пока статус committing — применение идёт.
 */
export const getClientImport = <ThrowOnError extends boolean = false>(options: Options<GetClientImportData, ThrowOnError>): RequestResult<GetClientImportResponses, GetClientImportErrors, ThrowOnError> => (options.client ?? client).get<GetClientImportResponses, GetClientImportErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/client-imports/{importId}',
    ...options
});

/**
 * Применить загрузку (фаза 2 — запись)
 *
 * Заводит гостей по строкам, прошедшим отбор. Дедупликация по телефону: строка на существующего гостя не создаёт второго, а пополняет его карточку (имя копится вариантом, §2.4), поэтому повторная загрузка того же файла безопасна. ⚠️ ВОЗВРАЩАЕТСЯ СРАЗУ, ПРИМЕНЯЕТ ФОНОМ. Захват пачки синхронный, дальше применение уходит в фоновую задачу, и соединения вызов не держит (`prima-clients`, `internal/transport/grpc/import_server.go`, `CommitImport`). Само применение долгое — их замер даёт 14 610 строк за 3 мин 54 с, потолок фоновой задачи 30 минут. Отсюда два следствия: увеличенный таймаут ИМЕННО НА ЭТУ РУЧКУ гейтвею НЕ нужен, она отвечает сразу; а интерфейс НЕ ДОЛЖЕН запирать менеджера модалкой «подождите» — он ведёт применение опросом getClientImport, а не ответом этого вызова.
 */
export const commitClientImport = <ThrowOnError extends boolean = false>(options: Options<CommitClientImportData, ThrowOnError>): RequestResult<CommitClientImportResponses, CommitClientImportErrors, ThrowOnError> => (options.client ?? client).post<CommitClientImportResponses, CommitClientImportErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/client-imports/{importId}/commit',
    ...options
});

/**
 * Отменить загрузку
 *
 * Отказ от разобранного файла. Отменять по существу нечего — записи ещё не было, — но загрузка закрывается явно, и повторный commit по ней уже не пройдёт. Отвечает самой загрузкой, чтобы экран показал закрытое состояние, а не догадывался о нём по отсутствию ответа.
 */
export const cancelClientImport = <ThrowOnError extends boolean = false>(options: Options<CancelClientImportData, ThrowOnError>): RequestResult<CancelClientImportResponses, CancelClientImportErrors, ThrowOnError> => (options.client ?? client).post<CancelClientImportResponses, CancelClientImportErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/client-imports/{importId}/cancel',
    ...options
});

/**
 * Строки загрузки
 *
 * Разбор проблемных строк: номер в файле, что стояло в ячейках и почему строка не прошла. Это рабочий инструмент, а не диагностика: менеджер по нему правит свой файл и заливает заново.
 */
export const listClientImportRows = <ThrowOnError extends boolean = false>(options: Options<ListClientImportRowsData, ThrowOnError>): RequestResult<ListClientImportRowsResponses, ListClientImportRowsErrors, ThrowOnError> => (options.client ?? client).get<ListClientImportRowsResponses, ListClientImportRowsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/client-imports/{importId}/rows',
    ...options
});

/**
 * Каналы компании
 *
 * Все каналы компании одним списком — аккаунты и боты одной моделью (Channel): подключённые и незавершённые подключения (`status: pending`).
 */
export const listChannels = <ThrowOnError extends boolean = false>(options?: Options<ListChannelsData, ThrowOnError>): RequestResult<ListChannelsResponses, ListChannelsErrors, ThrowOnError> => (options?.client ?? client).get<ListChannelsResponses, ListChannelsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels',
    ...options
});

/**
 * Бюджет канала — пределы, о которые текст спотыкается у гостя
 *
 * Источник — prima-inbox (`GetChannelLimits`): публикует их тот, кто применяет.
 * ⚠️ НЕ КЛАСТЬ ЭТИ ЧИСЛА ОБРАТНО В КАТАЛОГ АВТОРИНГА КОНТЕНТА. Они там жили и переехали сюда целиком: предел принадлежит каналу и установке, а копия в другом сервисе разойдётся молча (ответ бекенда 21.08, §2).
 * ⚠️ Параметра канала у ручки НЕТ, и это решение, а не упущение. Числа у каналов разные, но автор пишет ОДИН текст на все каналы сразу, и полезный ему ответ — САМЫЙ СТРОГИЙ из них (так же собраны числа в спеке, 4.5). Параметр потребовал бы от редактора выбрать канал там, где выбора нет. От текста ответ не зависит вовсе.
 */
export const getChannelLimits = <ThrowOnError extends boolean = false>(options?: Options<GetChannelLimitsData, ThrowOnError>): RequestResult<GetChannelLimitsResponses, GetChannelLimitsErrors, ThrowOnError> => (options?.client ?? client).get<GetChannelLimitsResponses, GetChannelLimitsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/limits',
    ...options
});

/**
 * Каталог типов канала
 *
 * Витрина «Подключить канал» строится из этого списка, а не из хардкода фронта (тот же приём, что и каталог движка сценариев, см. getScenarioCatalog) — новый тип канала появляется здесь без деплоя фронта. Каталог отдаёт только типы, которые в ЭТОЙ установке можно подключить: тип, у которого prima-connect отвечает `available = false` (адаптер не настроен — WhatsApp, например, в установке необязателен) или `connect_method = none` (SMS-провайдер), в список не входит. По каталогу же строятся и фильтры типов на экране.
 */
export const getChannelCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetChannelCatalogData, ThrowOnError>): RequestResult<GetChannelCatalogResponses, GetChannelCatalogErrors, ThrowOnError> => (options?.client ?? client).get<GetChannelCatalogResponses, GetChannelCatalogErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/catalog',
    ...options
});

/**
 * История событий по каналам
 *
 * Одна лента на всю компанию, не по одному каналу — какого канала касается запись, видно из текста события (ChannelEvent.text), например «MAX · Приём броней → нужен повторный вход».
 */
export const listChannelEvents = <ThrowOnError extends boolean = false>(options?: Options<ListChannelEventsData, ThrowOnError>): RequestResult<ListChannelEventsResponses, ListChannelEventsErrors, ThrowOnError> => (options?.client ?? client).get<ListChannelEventsResponses, ListChannelEventsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/events',
    ...options
});

/**
 * Каскад эскалации каналов
 *
 * Каскад компании по умолчанию — приоритетный порядок мессенджеров, в котором система пробует достучаться до гостя, пока он не ответил (пробуем первый, при неудаче — следующий; порядок элементов массива значим). Первый ответ гостя фиксирует мессенджер дальнейшего общения. Блок `reach` («Первый контакт») в сценарии может переопределить этот порядок для себя: его поле `config.channels` (BlockField с `kind: orderedChannels`) заменяет каскад компании на время этого шага; если свой каскад блок не задал, применяется каскад компании — тот, что возвращает эта ручка (см. также `saveChannelCascade`). Пул мессенджеров фиксирован (`max`/`telegram`/`vk`/`whatsapp`/`sms`). Какой именно подключённый канал (Channel) отвечает на попытку по мессенджеру — решает флаг `Channel.forGuests`, этот список только про порядок мессенджеров.
 */
export const getChannelCascade = <ThrowOnError extends boolean = false>(options?: Options<GetChannelCascadeData, ThrowOnError>): RequestResult<GetChannelCascadeResponses, GetChannelCascadeErrors, ThrowOnError> => (options?.client ?? client).get<GetChannelCascadeResponses, GetChannelCascadeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/cascade',
    ...options
});

/**
 * Сохранить каскад эскалации каналов
 *
 * Полная замена каскада компании по умолчанию — семантика та же, что у `getChannelCascade` (см. его description про связь с полем `config.channels` блока `reach`).
 */
export const saveChannelCascade = <ThrowOnError extends boolean = false>(options: Options<SaveChannelCascadeData, ThrowOnError>): RequestResult<SaveChannelCascadeResponses, SaveChannelCascadeErrors, ThrowOnError> => (options.client ?? client).put<SaveChannelCascadeResponses, SaveChannelCascadeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/cascade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Боты компании и ссылки на них
 *
 * По каждому мессенджеру: публичное имя бота, готовая ссылка и состояние (3.5). Нужно, чтобы менеджер мог открыть СВОЕГО бота и убедиться, что тот отвечает.
 *
 * ⚠️ Состояний ТРИ, и третье не сводится ко второму: `unknown` — «узнать не удалось». Временный сбой, показанный как «не подключён», отправит менеджера переподключать работающего бота.
 *
 * ⚠️ Ссылка здесь ОБЫЧНАЯ, без кода брони. Персональная ссылка гостя одноразовая и привязывает к брони тот чат, который её открыл; для гостя есть отдельная ручка переотправки.
 */
export const listBotLinks = <ThrowOnError extends boolean = false>(options?: Options<ListBotLinksData, ThrowOnError>): RequestResult<ListBotLinksResponses, ListBotLinksErrors, ThrowOnError> => (options?.client ?? client).get<ListBotLinksResponses, ListBotLinksErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/bot-links',
    ...options
});

/**
 * Начать подключение по QR
 *
 * Заводит асинхронную сессию подключения и возвращает QR-код (qrSvg) для сканирования в приложении мессенджера. Состояние — отдельным поллингом через getQrConnect по linkId. Годится только для типов с connect: qr в каталоге (ChannelType.connect) — для connect: token используется connectByToken.
 *
 * Канал заводится сразу, в статусе `pending`, и виден в списке, пока вход не завершён. Бросить подключение — `cancelQrConnect`: иначе незавершённый канал так и останется в списке.
 */
export const startQrConnect = <ThrowOnError extends boolean = false>(options: Options<StartQrConnectData, ThrowOnError>): RequestResult<StartQrConnectResponses, StartQrConnectErrors, ThrowOnError> => (options.client ?? client).post<StartQrConnectResponses, StartQrConnectErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/qr',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Отменить привязку
 *
 * Менеджер бросил подключение — «Отменить привязку» или закрыл окно, пока вход не пошёл: до сканирования, на шаге пароля, после провала или истечения кода.
 *
 * ⚠️ РЕШАЕТ ЖИВОЙ ШАГ СЕССИИ, а не её история: шлюз читает `GetOnboarding` перед удалением. Вход идёт или прошёл (`step = scanned` или `status = completed`) — 409 `LinkScanned`, и ничего не трогается: вход доводится до конца, а ненужный канал удаляют `deleteChannel` — тот отвязывает аккаунт как положено. Почему не удалять: удаление незавершённого канала НЕ останавливает попытку у адаптера (глагола отмены у prima-connect нет), и вход, довершившийся после удаления, оставит у адаптера живой аккаунт без канала — у WhatsApp связанное устройство и зеркало переписки, которые из Prima не отвязать, а номер больше не подключить («уже подключён»); у MAX — ту же вошедшую сессию без владельца. Ждём сканирования, ждём пароль (`awaiting_password` — вход ещё не случился), `expired`, `failed` (в том числе после скана) — 204, и подключение (новое или продолжение незавершённого) уносит свой канал. Живой шаг не прочитан (адаптер недоступен) — 503, ничего не тронуто.
 *
 * Окно не зовёт отмену, пока вход идёт («входим»), и пока летит `submitQrPassword` — решает по вердикту. 409 — гонка: код отсканировали между опросом и отменой. Сузить её дёшево: у WhatsApp шлюз перед живым чтением выжидает несколько секунд (скан в пути доходит до адаптера не сразу), — окно ответа не ждёт. Пока по этому linkId у шлюза летит `submitQrPassword`, отмена ждёт его вердикта: принят — 409 `LinkScanned`, иначе — по живому шагу.
 *
 * Перепривязка подключённого канала (relinkChannel у канала не в pending) — канал остаётся как был, а сессия истечёт сама. Что это за сессия, шлюз знает по linkId (ChannelLink.linkId).
 *
 * Право — то же, что на начало сессии (startQrConnect). Удалить без права удалять каналы оно позволяет только незавершённый канал этой сессии — по linkId, который выдал шлюз.
 *
 * Идемпотентна: повтор и отмена уже завершённой отменой или неизвестной сессии — тоже 204. Окно зовёт её, не дожидаясь ответа, — ему нечего показать, кроме того, что оно закрыто.
 */
export const cancelQrConnect = <ThrowOnError extends boolean = false>(options: Options<CancelQrConnectData, ThrowOnError>): RequestResult<CancelQrConnectResponses, CancelQrConnectErrors, ThrowOnError> => (options.client ?? client).delete<CancelQrConnectResponses, CancelQrConnectErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/qr/{linkId}',
    ...options
});

/**
 * Состояние QR-подключения
 *
 * Фронт поллит эту ручку раз в pollIntervalMs, пока state не станет connected, expired или failed. 404 — канала этой сессии нет в активной компании: его удалили или компанию в сессии сменили. Протухший код — не 404: сессия и её linkId живут, пока жив канал, и истёкшая отвечает 200 с state: expired сколь угодно долго.
 *
 * ⚠️ 503 — адаптер мессенджера сейчас не отвечает (шаг сессии читается у него вживую): это не конец подключения. Окно оставляет текущий экран и спрашивает снова на следующем тике.
 */
export const getQrConnect = <ThrowOnError extends boolean = false>(options: Options<GetQrConnectData, ThrowOnError>): RequestResult<GetQrConnectResponses, GetQrConnectErrors, ThrowOnError> => (options.client ?? client).get<GetQrConnectResponses, GetQrConnectErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/qr/{linkId}',
    ...options
});

/**
 * Перевыпустить QR-код
 *
 * Новый код для той же сессии linkId — после state: expired («показать новый код») или failed («начать заново»); state возвращается в waiting. Канал новый не заводится: сессия перевыпускает код для того же незавершённого канала.
 */
export const refreshQrConnect = <ThrowOnError extends boolean = false>(options: Options<RefreshQrConnectData, ThrowOnError>): RequestResult<RefreshQrConnectResponses, RefreshQrConnectErrors, ThrowOnError> => (options.client ?? client).post<RefreshQrConnectResponses, RefreshQrConnectErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/qr/{linkId}/refresh',
    ...options
});

/**
 * Отправить пароль аккаунта
 *
 * Ответ на state: password — у аккаунта мессенджера есть пароль входа (двухэтапная проверка), и одного сканирования мало. 204 — пароль принят: опрос продолжается, state станет scanned, затем connected.
 *
 * ⚠️ ПОКА ЗАПРОС ЛЕТИТ, ОТВЕТЫ ОПРОСА НЕ РИСОВАТЬ: опрос, обогнавший вердикт, ещё читает password, и форма мелькнула бы снова. Ответ может идти до ~30 секунд — сервер ждёт вердикта мессенджера.
 *
 * ⚠️ ПАРОЛЬ — ЧУЖОЙ СЕКРЕТ. Уходит в мессенджер как есть (пробелы — его часть, не обрезать), сервер его не хранит и не пишет в журналы; клиенту — не класть в кеш и не отдавать менеджеру паролей браузера.
 */
export const submitQrPassword = <ThrowOnError extends boolean = false>(options: Options<SubmitQrPasswordData, ThrowOnError>): RequestResult<SubmitQrPasswordResponses, SubmitQrPasswordErrors, ThrowOnError> => (options.client ?? client).post<SubmitQrPasswordResponses, SubmitQrPasswordErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/qr/{linkId}/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Подключить канал по токену
 *
 * Синхронное подключение: сервер сразу проверяет токен у провайдера и в одном ответе либо подключает канал (201), либо отвечает одной из четырёх ошибок. Годится только для типов с connect: token в каталоге (ChannelType.connect) — для connect: qr используется startQrConnect. `400 https://prima.ru/errors/channel-invalid-token` — «Токен неверный». `403 https://prima.ru/errors/channel-token-scope` — «У токена нет нужного доступа». `409 https://prima.ru/errors/channel-already-connected` — «Канал такого типа уже подключён»: возникает только у типов с `multiple: false` (боты — один канал на компанию). `503 https://prima.ru/errors/channel-provider-unavailable` — «Канал временно недоступен»: не ошибка запроса, провайдер мессенджера не отвечает, стоит повторить попытку позже.
 */
export const connectByToken = <ThrowOnError extends boolean = false>(options: Options<ConnectByTokenData, ThrowOnError>): RequestResult<ConnectByTokenResponses, ConnectByTokenErrors, ThrowOnError> => (options.client ?? client).post<ConnectByTokenResponses, ConnectByTokenErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/connect/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Удалить канал
 *
 * Отключает и удаляет канал целиком. Отменить нельзя — для временной остановки есть disableChannel (у каналов, где он есть в `Channel.actions`). Аккаунт WhatsApp prima-connect при этом отвязывает и НЕОБРАТИМО стирает переписку, которую хранит адаптер; что сказать в подтверждении, сервер кладёт в `ChannelAction.warning` действия `remove`.
 */
export const deleteChannel = <ThrowOnError extends boolean = false>(options: Options<DeleteChannelData, ThrowOnError>): RequestResult<DeleteChannelResponses, DeleteChannelErrors, ThrowOnError> => (options.client ?? client).delete<DeleteChannelResponses, DeleteChannelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}',
    ...options
});

/**
 * Изменить канал
 *
 * Оба поля тела необязательны — сервер меняет только переданные, пустое тело — 400. name — внутреннее имя (Channel.name): сервер обрезает пробелы по краям, пустая строка снимает имя, и канал снова зовётся именем по умолчанию. forGuests переключает участие в общении с гостями (см. Channel.forGuests) — не влияет на status.
 */
export const updateChannel = <ThrowOnError extends boolean = false>(options: Options<UpdateChannelData, ThrowOnError>): RequestResult<UpdateChannelResponses, UpdateChannelErrors, ThrowOnError> => (options.client ?? client).patch<UpdateChannelResponses, UpdateChannelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Перепривязать канал
 *
 * Перепривязка QR-канала. Доступна не только реактивно, для статуса needs_relogin (см. Channel.actions) — менеджер может перепривязать и уже активный, здоровый MAX-канал проактивно, не дожидаясь разрыва сессии. Та же QR-сессия, что и startQrConnect, но заведённая для уже существующего channelId, а не для нового канала: после сканирования QR канал обновляется на месте, а не создаётся заново. Состояние — тем же поллингом getQrConnect по linkId из ответа; пароль, если аккаунт им защищён, — тем же submitQrPassword. У канала в pending (подключение не завершено) это продолжение подключения: новый код для того же канала. У WhatsApp повторного входа нет (prima-connect: supports_relogin = false) — только продолжение незавершённого; действия relink у подключённого WhatsApp сервер не отдаёт.
 */
export const relinkChannel = <ThrowOnError extends boolean = false>(options: Options<RelinkChannelData, ThrowOnError>): RequestResult<RelinkChannelResponses, RelinkChannelErrors, ThrowOnError> => (options.client ?? client).post<RelinkChannelResponses, RelinkChannelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}/relink',
    ...options
});

/**
 * Сменить токен канала
 *
 * Синхронная замена токена уже подключённого канала (бота) — сервер проверяет новый токен у провайдера и либо сохраняет его (200), либо отвечает одной из тех же ошибок, что и connectByToken. `400 https://prima.ru/errors/channel-invalid-token` — «Токен неверный». `403 https://prima.ru/errors/channel-token-scope` — «У токена нет нужного доступа». `503 https://prima.ru/errors/channel-provider-unavailable` — «Канал временно недоступен», стоит повторить попытку позже.
 */
export const changeChannelToken = <ThrowOnError extends boolean = false>(options: Options<ChangeChannelTokenData, ThrowOnError>): RequestResult<ChangeChannelTokenResponses, ChangeChannelTokenErrors, ThrowOnError> => (options.client ?? client).post<ChangeChannelTokenResponses, ChangeChannelTokenErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Включить канал
 *
 * Снимает статус disabled («приостановлен вручную») — канал возвращается к работе.
 */
export const enableChannel = <ThrowOnError extends boolean = false>(options: Options<EnableChannelData, ThrowOnError>): RequestResult<EnableChannelResponses, EnableChannelErrors, ThrowOnError> => (options.client ?? client).post<EnableChannelResponses, EnableChannelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}/enable',
    ...options
});

/**
 * Приостановить канал
 *
 * Переводит канал в status: disabled вручную — канал остаётся подключённым, просто не используется, пока его не включат обратно (enableChannel).
 */
export const disableChannel = <ThrowOnError extends boolean = false>(options: Options<DisableChannelData, ThrowOnError>): RequestResult<DisableChannelResponses, DisableChannelErrors, ThrowOnError> => (options.client ?? client).post<DisableChannelResponses, DisableChannelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/channels/{channelId}/disable',
    ...options
});

/**
 * Настройки платежей
 *
 * Только настройки — провайдеры, реквизиты, залог. Сами платежи по бронированиям исполняет движок сценариев (см. paths/scenarios.yaml), отдельной ручки приёма платежа в этом контракте нет.
 */
export const getPaymentSettings = <ThrowOnError extends boolean = false>(options?: Options<GetPaymentSettingsData, ThrowOnError>): RequestResult<GetPaymentSettingsResponses, GetPaymentSettingsErrors, ThrowOnError> => (options?.client ?? client).get<GetPaymentSettingsResponses, GetPaymentSettingsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/payments/settings',
    ...options
});

/**
 * Сохранить настройки залога
 */
export const saveDepositSettings = <ThrowOnError extends boolean = false>(options: Options<SaveDepositSettingsData, ThrowOnError>): RequestResult<SaveDepositSettingsResponses, SaveDepositSettingsErrors, ThrowOnError> => (options.client ?? client).put<SaveDepositSettingsResponses, SaveDepositSettingsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/payments/deposit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Список источников синхронизации броней
 */
export const listSources = <ThrowOnError extends boolean = false>(options?: Options<ListSourcesData, ThrowOnError>): RequestResult<ListSourcesResponses, ListSourcesErrors, ThrowOnError> => (options?.client ?? client).get<ListSourcesResponses, ListSourcesErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/sources',
    ...options
});

/**
 * Что именно синхронизируется с источниками
 *
 * Пояснительный список для экрана источников — не привязан к конкретному Source.
 */
export const getSourceSyncScope = <ThrowOnError extends boolean = false>(options?: Options<GetSourceSyncScopeData, ThrowOnError>): RequestResult<GetSourceSyncScopeResponses, GetSourceSyncScopeErrors, ThrowOnError> => (options?.client ?? client).get<GetSourceSyncScopeResponses, GetSourceSyncScopeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/sources/sync-scope',
    ...options
});

/**
 * Настройки AI-консьержа
 *
 * Возвращает пять серверных секций экрана: режим участия, характер, модель, лимиты и аналитику. Для собственной модели токен write-only: чтение возвращает только tokenState и lastCheck, а не сам токен.
 */
export const getConcierge = <ThrowOnError extends boolean = false>(options?: Options<GetConciergeData, ThrowOnError>): RequestResult<GetConciergeResponses, GetConciergeErrors, ThrowOnError> => (options?.client ?? client).get<GetConciergeResponses, GetConciergeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/concierge',
    ...options
});

/**
 * Сохранить настройки AI-консьержа
 *
 * Сохраняет только клиентские настройки экрана: режим участия, редактируемые поля характера, выбор модели и лимиты. Серверные/read-only поля ответа не передаются обратно. Для provider = own фронт не должен сохранять настройки, пока live-check POST /concierge/model-check не вернул успех на текущую комбинацию endpoint/model/token/prices.
 */
export const saveConcierge = <ThrowOnError extends boolean = false>(options: Options<SaveConciergeData, ThrowOnError>): RequestResult<SaveConciergeResponses, SaveConciergeErrors, ThrowOnError> => (options.client ?? client).put<SaveConciergeResponses, SaveConciergeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/concierge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Проверить собственную языковую модель
 *
 * Серверный live-check для provider = own. Фронт не проверяет токен, endpoint или модель самостоятельно: он только отправляет настройки и показывает серверный результат либо Problem.
 */
export const checkConciergeModel = <ThrowOnError extends boolean = false>(options: Options<CheckConciergeModelData, ThrowOnError>): RequestResult<CheckConciergeModelResponses, CheckConciergeModelErrors, ThrowOnError> => (options.client ?? client).post<CheckConciergeModelResponses, CheckConciergeModelErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/concierge/model-check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Журнал аудита
 */
export const listAuditEvents = <ThrowOnError extends boolean = false>(options?: Options<ListAuditEventsData, ThrowOnError>): RequestResult<ListAuditEventsResponses, ListAuditEventsErrors, ThrowOnError> => (options?.client ?? client).get<ListAuditEventsResponses, ListAuditEventsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/audit/events',
    ...options
});

/**
 * Журнал выдач кодов доступа
 *
 * Каждая запись — ВЫДАЧА кода гостю по брони: сценарий дошёл до шага, бронь выполнила условия, код ушёл наружу. ⚠️ Записей «менеджер посмотрел» здесь не бывает и быть не может — сервис секретов не отдаёт значения менеджеру вовсе (2.9), и операции раскрытия у нас поэтому нет. Отдельная ручка от listAuditEvents: выдачи требуют собственного списка с полями объекта, секрета и брони, которых нет в общем событии аудита.
 */
export const listSecretReveals = <ThrowOnError extends boolean = false>(options?: Options<ListSecretRevealsData, ThrowOnError>): RequestResult<ListSecretRevealsResponses, ListSecretRevealsErrors, ThrowOnError> => (options?.client ?? client).get<ListSecretRevealsResponses, ListSecretRevealsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/audit/secret-reveals',
    ...options
});

/**
 * Справочники для формы создания брони
 */
export const getBookingFormReference = <ThrowOnError extends boolean = false>(options?: Options<GetBookingFormReferenceData, ThrowOnError>): RequestResult<GetBookingFormReferenceResponses, GetBookingFormReferenceErrors, ThrowOnError> => (options?.client ?? client).get<GetBookingFormReferenceResponses, GetBookingFormReferenceErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: 'prima_session',
            type: 'apiKey'
        }],
    url: '/reference/booking-form',
    ...options
});
